<script>
import ComposerInlineSelect from '@modules/aawz-intelligence-v2/components/composer-inline-select/composer-inline-select.vue'
import ComposerAttachments from '@modules/aawz-intelligence-v2/components/composer-attachments/composer-attachments.vue'
import { imagensDoClipboard } from '@modules/aawz-intelligence-v2/utils/imagens-do-clipboard'
import {
  EXTENSOES_PERMITIDAS,
  MAX_ANEXOS,
  MAX_BYTES_POR_ANEXO,
} from '@modules/aawz-intelligence-v2/constants/Anexos'
import { getExtension } from '@modules/tarefas/utils/attachments'
import { mensagemCanalDesconhecido } from '@modules/aawz-intelligence-v2/utils/canal-do-anexo'
import { fileSize } from '@utils/Format'
import AgentSelect from '@modules/aawz-intelligence-v2/components/agent-select/agent-select.vue'
import EscopoSelect from '@modules/aawz-intelligence-v2/components/escopo-select/escopo-select.vue'
import VozSelect from '@modules/aawz-intelligence-v2/components/voz-select/voz-select.vue'
import { apiVoz } from '@modules/aawz-intelligence-v2/api/apiVoz'
import { tocarAmostra } from '@modules/aawz-intelligence-v2/utils/amostra-de-voz'
import ComposerFerramentas from '@modules/aawz-intelligence-v2/components/composer-ferramentas/composer-ferramentas.vue'
import { atalhoDigitado } from '@modules/aawz-intelligence-v2/utils/atalho-digitado'
import ComposerVozOrb, {
  MODO_AGUARDANDO,
  MODO_CONSULTANDO,
  MODO_IA,
  MODO_USUARIO,
} from '@modules/aawz-intelligence-v2/components/composer-voz-orb/composer-voz-orb.vue'
import ComposerDitarEspectro from '@modules/aawz-intelligence-v2/components/composer-ditar-espectro/composer-ditar-espectro.vue'
import ComandoChip from '@modules/aawz-intelligence-v2/components/comando-chip/comando-chip.vue'
import {
  motorDeVoz,
  iniciar as iniciarMotorDeVoz,
  parar as pararMotorDeVoz,
  cancelar as cancelarMotorDeVoz,
  alternarMudo as alternarMudoMotorDeVoz,
  sairDoModoDeVoz as sairDoModoDeVozMotor,
  paradaDeTurnoDisponivel,
  registrarDestino,
  desregistrarDestino,
  MODO_DITAR,
  MODO_VOZ,
  MENSAGEM_QUEDA_PARA_POR_TURNOS,
} from '@modules/aawz-intelligence-v2/utils/motor-de-voz'
// [spec-008 T030c] A tela implementando o `Destino` do contrato em tempo real
// — sem isto a bandeira ligada abre sessão PAGA e MUDA (o `MediaStream` de
// volta não é anexado a elemento nenhum, e `estadoDaFala` não acompanha a IA).
import { criarDestinoDeVozTempoReal } from '@modules/aawz-intelligence-v2/utils/destino-de-voz-tempo-real'
import {
  fluxoRemotoAtual,
  vozTempoReal,
} from '@modules/aawz-intelligence-v2/utils/estado-da-voz-tempo-real'
import { montarContextoDeVozTempoReal } from '@modules/aawz-intelligence-v2/utils/contexto-de-voz-tempo-real'
import { COMPOSER_CHAT } from '@modules/aawz-intelligence-v2/constants/TextChat'
import { GlobalBus } from '@services/bus'
import { MODAL } from '@constants/Text'
import {
  ESCOPO_AGENTES,
  ESCOPO_CLIENTES,
  ESCOPO_MODELOS,
} from '@modules/aawz-intelligence-v2/utils/ia-palette/secoes'
import { COPY_VOZ, COPY_VOZ_TEMPO_REAL } from './copy-de-voz'
import { sendMessageAlturaMixin } from './send-message-altura-mixin'
import { sendMessageCatalogoComandosMixin } from './send-message-catalogo-comandos-mixin'
import { sendMessageAnexosUploadMixin } from './send-message-anexos-upload-mixin'
import { sendMessageHistoricoMixin } from './send-message-historico-mixin'
import { sendMessageChipClipboardMixin } from './send-message-chip-clipboard-mixin'

const DEFAULT_STORE_MODULE = 'aawz-intelligence-v2'
// Rodapé de hoje. Continua sendo o default: o disclaimer só entra onde o
// consumidor pede (ver prop `hideDisclaimer`).
const DICA_TECLADO = 'Enter para enviar \u2022 Shift+Enter para nova linha'

// A barra que abre o menu de ferramentas, como no ChatGPT e no Claude.
const COMANDO_DE_FERRAMENTAS = '/'

export default {
  name: 'IntelligenceV2SendMessage',
  components: {
    ComposerInlineSelect,
    ComposerAttachments,
    AgentSelect,
    EscopoSelect,
    VozSelect,
    ComposerFerramentas,
    ComposerVozOrb,
    ComposerDitarEspectro,
    ComandoChip,
  },
  mixins: [
    sendMessageAlturaMixin,
    sendMessageCatalogoComandosMixin,
    sendMessageAnexosUploadMixin,
    sendMessageHistoricoMixin,
    sendMessageChipClipboardMixin,
  ],
  props: {
    value: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Pergunte sobre seus clientes, tarefas, oportunidades...',
    },
    // ★ [14/09/2026] Saldo de créditos ESGOTADO: o envio trava (`canSend` false,
    // botão desabilitado) — o campo continua editável e a faixa que explica o
    // porquê entra pelo slot `cabecalho`. Opt-in por prop: só a superfície que
    // conhece a carteira (`view-chat` com `comAvisoDeCreditos`) passa; popup,
    // painel do Hub, Fee-Based e ai-framework ficam como estão.
    envioBloqueado: {
      type: Boolean,
      default: false,
    },
    // ★ [18/09/2026, spec-009 US-2] O botão de enviar PULSA — hoje só no fim da
    // primeira pergunta digitada pelo chat (`view-chat-primeira-pergunta.mixin.js`),
    // para o consultor ver DE ONDE a mensagem vai sair antes de ela sair.
    //
    // Reusa `az-highlight-pulse` (`src/design/helpers/_effects.sass`), a MESMA
    // classe do "Minhas transcrições" do CRM — `drop-shadow` em `var(--primary)`,
    // então acompanha o white-label sozinha. Opt-in: quem não passa a prop fica
    // byte a byte como antes.
    pulsarEnvio: {
      type: Boolean,
      default: false,
    },
    // Sobrescreve `--az-pulse-duration` (default 1.2s na classe) no PRÓPRIO
    // botão — mesmo mecanismo de `highlightDuration` do `BaseSelfFilterToggle`.
    // String CSS (ex.: `'900ms'`); `null` mantém o default.
    duracaoDoPulsoDeEnvio: {
      type: String,
      default: null,
    },
    modelLocked: {
      type: Boolean,
      default: false,
    },
    // spec-003 §5 (decisão §3-A opção (a)): namespace do store parametrizável.
    // Default preserva o IA CRM byte a byte (converte mapState/mapActions em acessos
    // dinâmicos via `this.storeModule` — mesmas strings de dispatch no default).
    storeModule: {
      type: String,
      default: DEFAULT_STORE_MODULE,
    },
    // spec-003 §5 / G5: suprime o seletor de modelo E o toggle thinking. O parceiro
    // NUNCA vê/escolhe modelo (RF2.6/NC-3). Também pula o load de supportedModels no
    // mounted (o slice `chat` do ai-framework não tem esse estado/action).
    // Composer no formato do ChatGPT: uma linha fina, "+" na esquerda, e à
    // direita só ícones e o enviar. Ligada apenas pela visão imersiva, a partir
    // do `MODO_DA_PAGINA`.
    //
    // ⚠️ Default `false` de propósito: a mesma caixa serve o popup, a rota
    // cheia, o painel do Hub e o Especialista Fee-Based, e todos mantêm o
    // desenho de hoje.
    // Módulos do menu do "+", já recortados nos do escritório pela superfície
    // hospedeira. Vazio = o "+" volta a ser o botão de anexo de sempre.
    ferramentas: {
      type: Array,
      default: function () {
        return []
      },
    },
    // ★ [G-2 do QA, 19/09/2026] Os ATALHOS de negócio que a tela oferece
    // (`{titulo, comando:{slug}}` — as ações de `moduloDeAtalhosDeNegocio`).
    // O composer só os usa para NÃO mentir: enquanto o texto digitado é um
    // atalho conhecido (`/pré-reunião Ilo Santos`), o menu do "+" fica
    // fechado em vez de anunciar "Nenhuma ferramenta com esse nome" sobre um
    // comando que existe e vai funcionar. Quem DESPACHA é o pai
    // (`view-chat.vue::onSendMessage`) — aqui não há decisão de envio.
    //
    // Opt-in (`[]`): só a `/home-ia` passa. Popup, painel do Hub, Fee-Based
    // e ai-framework seguem byte a byte o de hoje.
    atalhosDeNegocio: {
      type: Array,
      default: function () {
        return []
      },
    },
    // Módulo escolhido no menu — desenha o chip na caixa. O estado mora no pai
    // (o `view-chat`), porque o carrossel abaixo da caixa lê o mesmo valor.
    ferramentaAtiva: {
      type: Object,
      default: null,
    },
    estiloLimpo: {
      type: Boolean,
      default: false,
    },
    hideModelSelect: {
      type: Boolean,
      default: false,
    },
    // Estado vazio: composer maior e mais arredondado (28px em vez de 24px).
    large: {
      type: Boolean,
      default: false,
    },
    // Liga/desliga o disclaimer regulatório (S4) no rodapé; desligado, o
    // rodapé volta a ser a dica de teclado de hoje. Default `false` porque
    // `vue/no-boolean-default` proíbe `true` — então os dois consumidores que
    // NÃO podem ganhar o disclaimer passam `hide-disclaimer` explicitamente:
    // o ai-framework já renderiza o dele logo acima (`agent-chat.vue`) e o
    // popup tem de manter o layout do #1939 (AC-8.3).
    hideDisclaimer: {
      type: Boolean,
      default: false,
    },
    // [owner, 19/09/2026] *"no modo chat aberto não faça aparecer o texto
    // 'Enter para enviar • Shift+Enter para nova linha'"*. A dica é puramente
    // cosmética e já estava documentada como tal; numa tela cheia de chat ela
    // vira ruído permanente, e durante o onboarding chega a mentir — o
    // composer está TRAVADO (`envioTravado`) e a linha continua ensinando a
    // enviar.
    //
    // ⚠️ Opt-in, como todo o resto deste composer: popup, painel do Hub,
    // Fee-Based e ai-framework não passam a prop e não mudam de assinatura.
    //
    // ⚠️ E ela NÃO silencia a dica de ARGUMENTO do atalho
    // (`dicaDeArgumentoDoAtalho`, que divide a mesma linha): aquela é
    // funcional — diz o que digitar depois de `/pré-reunião` — e some sozinha
    // quando não há atalho ativo.
    semDicaDeTeclado: {
      type: Boolean,
      default: false,
    },
    // Chip do agente à esquerda. Fora do chat IA não há catálogo de agentes.
    // Liga o seletor de ESCOPO (cliente) ao lado do agente. Opt-in: as demais
    // superficies (popup, painel do Hub, Fee-Based, ai-framework) nao mudam.
    escopoDeCliente: {
      type: Boolean,
      default: false,
    },
    // Clientes ja filtrados pelo pai — o composer nao le store de usuario, para
    // seguir montavel sem sessao no teste.
    clientes: {
      type: Array,
      default: () => [],
    },
    clienteEscopo: {
      type: Object,
      default: null,
    },
    // spec-009 [T008] — o agente ativo desta conversa (getter
    // `agenteAtualDaConversa`), repassado ao chip de escopo. `null` ⇒ o chip
    // não instancia o badge (AC-4.5).
    agenteAtivo: {
      type: Object,
      default: null,
    },
    showAgentSelect: {
      type: Boolean,
      default: false,
    },
    /**
     * Se o palette oferece "Anexar carteira" — o extrato do cliente indo para
     * a IA ler (spec-004 do Fee Fixo).
     *
     * Prop, e não uma flag global, porque a capacidade é do AGENTE: só o
     * Especialista Fee-Based tem para onde mandar o arquivo. Nas outras
     * superfícies o comando não aparece, e `default: false` mantém popup, rota
     * cheia e painel do Hub exatamente como estão.
     *
     * ⚠️ Nada a ver com `anexosLiberados`, que é o anexo GENÉRICO do composer
     * (imagem na bolha) e segue desligado: aquele caminho não tem campo no
     * `POST /chat`. Este tem endpoint próprio e funciona ponta a ponta.
     */
    anexoDeCarteiraLiberado: {
      type: Boolean,
      default: false,
    },
    // Já filtrado por feature flag pelo pai (`agentesVisiveis($access)`).
    agentes: {
      type: Array,
      default: function () {
        return []
      },
    },
    agenteAtivoId: {
      type: String,
      default: '',
    },
    // Conversa já iniciada: o lock é do BACKEND (`usecase_ia_crm_chat.py`
    // sobrescreve a persona recebida ao retomar), a UI só o torna visível.
    agenteTravado: {
      type: Boolean,
      default: false,
    },
    // ★ Conversa com histórico: o CLIENTE também não muda mais. O backend
    // vincula na criação e não re-vincula quem retoma — trocar aqui seria
    // ignorado em silêncio, o mesmo motivo dos dois locks acima.
    escopoTravado: {
      type: Boolean,
      default: false,
    },
    // Gap G3: monta o "+" e a fila de chips. O gatilho continua desabilitado
    // até o envio ter canal para arquivo — ver `anexosDesabilitados`.
    showAttachments: {
      type: Boolean,
      default: false,
    },
    // Destrava o anexo. `default: false` é o que mantém popup, rota cheia,
    // painel do Hub e Fee-Based exatamente como hoje — nenhum deles passa a
    // prop. Quem liga é a funcionalidade `IA - Analise Agentica` do
    // escritório, lida em `utils/anexos-liberados.js` (spec-003 T306).
    anexosLiberados: {
      type: Boolean,
      default: false,
    },
    /**
     * Cursor no campo assim que ESTE composer monta.
     *
     * ★ Quem foca é o próprio componente, e não a view: ela monta ANTES dele (o
     * composer do herói entra por slot dentro do `EmptyMessages`), então no
     * `mounted` dela o ref ainda é `undefined`. Medido — `$nextTick` mais um
     * `requestAnimationFrame` não bastavam. Aqui o momento é exato por
     * construção, sem espera arbitrária.
     *
     * Opt-in: só a `/ia` passa. Nas outras superfícies o chat divide a tela
     * (popup, painel do Hub, drawer do Fee-Based) e roubar o foco na montagem
     * tiraria o cursor de onde a pessoa estava.
     */
    focarAoMontar: {
      type: Boolean,
      default: false,
    },
    /**
     * spec-016 [T005] — liga o seletor de voz do Modo de Voz. Opt-in, como
     * `escopoDeCliente`: só a `/ia` (`view-chat.vue`) passa `true`; popup,
     * painel do Hub, Fee-Based e ai-framework não mudam. Sem a prop, o
     * catálogo nem é carregado (`mounted()` abaixo) e nada é despachado no
     * store — evita o `[vuex] unknown action type` de `setVozSelecionada`
     * nos namespaces (`feeFixoIa`, `aiFramework`) que não têm essa action.
     */
    mostrarSeletorDeVoz: {
      type: Boolean,
      default: false,
    },
    /**
     * spec-008 [T030c] — a superfície do piloto de voz em TEMPO REAL
     * (`ia_operacional` | `consultor_estrategico` | `fee_fixo`; o vocabulário
     * FECHADO é do servidor e não é duplicado no front).
     *
     * ★ **É esta prop, e não a bandeira, que faz a superfície entrar no
     * piloto** — a bandeira é por escritório e o piloto é por superfície
     * (D-9/N13). Sem ela, popup, painel do Hub, Fee-Based e ai-framework, que
     * montam este MESMO composer, seguem byte a byte no caminho por turnos
     * mesmo num escritório com a bandeira ligada. Ver
     * `utils/contexto-de-voz-tempo-real.js`.
     */
    superficieDeVoz: {
      type: String,
      default: '',
    },
    /**
     * spec-008 [T030c] — o `delegar` do `ContextoDeSessao`: o `POST /chat` de
     * sempre, que é por onde o cérebro e o RBAC ficam na AAWZ (D-4). Quem o
     * implementa é a SUPERFÍCIE (só ela sabe conduzir um turno de chat); este
     * componente apenas o repassa para baixo.
     */
    delegarVoz: {
      type: Function,
      default: null,
    },
    /** spec-008 [T030c] — a conversa a que a sessão de voz pertence. */
    idConversaDeVoz: {
      type: String,
      default: '',
    },
    /**
     * ★ spec-008 [T065] — o `lerValorParcialDoTurno` do `ContextoDeSessao`
     * (D-O-5): *"pode até adiantar número se já tiver isso"*.
     *
     * Getter, chamado a cada acompanhamento da espera — não um valor: o
     * cartão entra no store no MEIO do turno, e um valor lido na abertura
     * seria `null` para sempre. Quem sabe lê-lo é a SUPERFÍCIE (só ela tem o
     * store da conversa); este componente apenas o repassa, como faz com o
     * `delegar`. Sem a prop, a voz remete e não fala número — que é o
     * comportamento anterior à D-O-5 e é seguro.
     */
    lerValorParcialDeVoz: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      // Arrastando um arquivo por cima da caixa. Só visual — quem aceita é o
      // `@drop`.
      arrastando: false,
      // spec-016 [T004]/[T005] — catálogo curado de vozes (US-2 AC3) e o
      // estado da amostra em voo. `catalogoDeVozes` só é carregado quando
      // `mostrarSeletorDeVoz` está ligado (ver `mounted()`).
      catalogoDeVozes: [],
      amostraTocandoId: '',
      amostraErro: null,
    }
  },
  computed: {
    /**
     * DÍVIDA-anexo (05/09): a fila de anexos pendentes vive FORA desta
     * instância, em `utils/anexos-pendentes.js` (`filaDeAnexos`, do mixin de
     * upload) — mesmo padrão de `motorDeVoz` logo abaixo. `view-chat.vue` tem
     * DUAS instâncias mutuamente exclusivas deste componente (herói/vazio ×
     * rodapé/conversa), trocadas por `v-if`, e um anexo anexado ANTES da
     * primeira mensagem de uma conversa nova morria na troca porque
     * `data() { arquivos: [] }` local era destruído junto com a instância do
     * herói.
     */
    arquivos: {
      get() {
        return this.filaDeAnexos.arquivos
      },
      set(valor) {
        this.filaDeAnexos.arquivos = valor
      },
    },
    // Vue 2 REMOVE o atributo quando o valor é `false` — `aria-pressed`
    // precisa da string "false" para o leitor de tela saber que é um toggle.
    mudoAriaPressed() {
      return String(this.microfoneMutado)
    },
    /**
     * Entrada de voz (v1, por turnos) — o ESTADO vive em `motorDeVoz`
     * (`utils/motor-de-voz.js`), fora desta instância. Motivo: a `/ia`
     * (`view-chat.vue`) tem DUAS instâncias mutuamente exclusivas deste
     * componente (herói/vazio × rodapé/conversa), trocadas via `v-if` — e
     * uma gravação em andamento não pode ser interrompida pela troca. Estas
     * seis computeds só EXPÕEM o motor pro template/métodos desta
     * instância; nenhuma delas é dona do dado.
     */
    gravando() {
      return motorDeVoz.gravando
    },
    modoDeVoz() {
      return motorDeVoz.modoDeVoz
    },
    microfoneMutado() {
      return motorDeVoz.microfoneMutado
    },
    nivelDoMicrofone() {
      return motorDeVoz.nivelDoMicrofone
    },
    transcrevendo() {
      return motorDeVoz.transcrevendo
    },
    // 'usuario' | 'ia' | null — quando não-nulo, o <ComposerVozOrb> aparece
    // acima da caixa. `ia` é setado pelo motor (`fala-da-ia.js`, via
    // `motor-de-voz.js::reproduzirResposta`/fila de fala), nunca por aqui.
    estadoDaFala() {
      return motorDeVoz.estadoDaFala
    },
    // [feedback do usuário, 04/09] Sessão de Modo de Voz ativa (do clique na
    // bolha até X/Esc de verdade) — controla se o "X de sair" abaixo aparece
    // enquanto a IA fala (ou num respiro entre o fim da fala e o re-arme
    // automático do mic), estados em que `gravando` já é `false`.
    sessaoDeVozAtiva() {
      return motorDeVoz.sessaoDeVozAtiva
    },
    /**
     * ★ [T049] Há um turno a **parar e enviar** na sessão em curso?
     *
     * É o que escolhe entre o X PRETO ("Parar e enviar", do v1) e o X NEUTRO
     * ("Sair do Modo de Voz"). Numa sessão em TEMPO REAL não existe turno a
     * parar — quem o julga é o provedor, e o protocolo medido não tem evento
     * cliente→servidor de "acabei de falar". O botão preto ali era tecla
     * morta sobre sessão PAGA: foi assim que o X deixou de fechar a conversa.
     *
     * ⚠️ **Isto não é ler o `nome` do transporte** (que o contrato proíbe a
     * componente de tela): a fachada responde por CAPACIDADE da interface, e
     * um terceiro transporte responde certo sem ninguém tocar aqui.
     *
     * ⚠️ **A reatividade vem de `gravando`/`modoDeVoz`, lidos ANTES** — e
     * não é sorte: o transporte da sessão é declarado por `abrirTransporte`
     * ANTES de `gravando` virar `true`, e volta ao v1 no fim. A abertura e o
     * fim da sessão são os únicos instantes em que a resposta pode mudar, e
     * os dois passam por essas bordas.
     */
    podeParaEEnviar() {
      return this.gravando && this.modoDeVoz && paradaDeTurnoDisponivel()
    },
    /**
     * ★ [spec-008 T060] A consulta SAIU e a resposta não voltou.
     *
     * Não é flag nova nem estado paralelo: são os dois sinais que a tela já
     * tem de "fui buscar" — o `transcrevendo` do caminho por turnos (o áudio
     * virando texto antes do envio) e o `loading`, que na `/ia` é o
     * `turnoEmVoo` (`chatLoading || enviando`), ligado pelo MESMO
     * `enviarMensagem` que a delegação da voz em tempo real chama
     * (`view-chat.vue::delegarVozTempoReal`). Os dois transportes acendem,
     * cada um pelo seu caminho, sem este componente saber qual está no
     * comando — que é o que o contrato exige (US-3 AC3).
     */
    consultandoNaVoz() {
      if (!this.sessaoDeVozAtiva) return false
      return Boolean(this.transcrevendo || this.loading)
    },
    /**
     * O `mode` de fato passado pro <ComposerVozOrb>.
     *
     * ★ [spec-008 T060] **Com sessão viva, esta computed NUNCA devolve
     * `null`** — é essa a correção. Ela devolvia, e a orb sumia: em tempo
     * real `estadoDaFala` só vale `'ia'` (o `'usuario'` é do VAD do v1, que o
     * N4 proíbe aqui) e `gravando` fica `true` a sessão inteira, então a
     * janela "microfone aberto, IA calada" — a maior parte de uma conversa —
     * caía no `return null` e o consultor ficava sem saber que o microfone
     * estava aberto **numa sessão paga por minuto**. O indicador some no
     * `encerrada` e só nele.
     *
     * A ordem é a da especificidade, e cada linha é um fato diferente:
     *
     * | estado | o que é verdade |
     * |---|---|
     * | `ia` | ela está falando AGORA — vence tudo |
     * | `consultando` | a pergunta saiu, a resposta não voltou |
     * | `aguardando` | o microfone está MUDO |
     * | `usuario` | o microfone é seu — ouvindo em silêncio ou você falando |
     * | `aguardando` | sessão viva, microfone fechado |
     *
     * ⚠️ **`microfoneMutado` e `consultandoNaVoz` vêm ANTES de
     * `estadoDaFala === 'usuario'`, e isto foi medido na tela**: no caminho
     * por turnos, `'usuario'` é escrito na ABERTURA da gravação
     * (`transporte-por-turnos.js::_iniciarEstadoDeGravacao`) e fica lá a
     * sessão inteira — não é "ele está falando agora", é "o microfone é
     * dele". Lido primeiro, ele engolia os dois estados seguintes: com o mic
     * MUDO a orb continuava "ouvindo" (a tela afirmando captação que não
     * existe — o mesmo erro que o `aguardando` da [spec-017 T004] veio
     * corrigir, do outro lado) e durante a consulta ela nunca virava
     * `consultando`. A unitária não pegava porque não setava `estadoDaFala`
     * junto; a tela pegou na primeira sessão real.
     *
     * ⚠️ `'ia'` fica no topo porque é fato sobre o ALTO-FALANTE, não sobre o
     * microfone: ela falando com o meu mic mudo continua sendo ela falando.
     */
    estadoVisualDoOrb() {
      if (this.estadoDaFala === MODO_IA) return MODO_IA
      if (!this.sessaoDeVozAtiva) return this.estadoDaFala || null
      if (this.consultandoNaVoz) return MODO_CONSULTANDO
      if (this.microfoneMutado) return MODO_AGUARDANDO
      if (this.estadoDaFala || this.gravando) return MODO_USUARIO
      return MODO_AGUARDANDO
    },
    /**
     * spec-008 [T030c] — o que a TELA mostra da sessão em tempo real. O estado
     * vive FORA da instância (`utils/estado-da-voz-tempo-real.js`), mesmo
     * motivo do `motorDeVoz` logo acima: a troca herói↔rodapé destrói esta
     * instância e monta outra, e uma frase em progresso não pode sumir no
     * meio por causa de um `v-if` de layout.
     */
    // A transcrição EM CURSO vence a fechada: a parcial é o que o consultor
    // está dizendo agora, e mostrar as duas exibiria a mesma frase em duas
    // versões, a de cima sempre pior.
    transcricaoDeVoz() {
      return vozTempoReal.transcricaoParcial || vozTempoReal.transcricaoDoTurno
    },
    // Só numa sessão de voz: o texto do último turno sobrevive ao fim da
    // sessão no estado (é dele que a medição se serve), e deixá-lo na tela
    // depois do X faria a linha ficar pendurada sob o composer vazio.
    mostrarTranscricaoDeVoz() {
      return Boolean(this.sessaoDeVozAtiva && this.transcricaoDeVoz)
    },
    /**
     * ★ D-13/N16 — a remissão ao cartão. O composer diz que existe decisão
     * esperando; **o valor, o cliente, o ativo e a data-base estão no cartão
     * da conversa**, nunca nesta linha e nunca na fala.
     */
    propostaDeVozAguardando() {
      return vozTempoReal.propostaAguardando
    },
    // [T035] "Vou encerrar" ANTES do corte — sem isto o teto corta a sessão
    // paga e a tela segue desenhando voz sobre um canal morto.
    avisoDeVozTempoReal() {
      const aviso = vozTempoReal.avisoDeEncerramento
      if (!aviso) return ''
      return COPY_VOZ_TEMPO_REAL.avisoDeEncerramento(aviso.segundosRestantes)
    },
    rotulosDeVozTempoReal() {
      return COPY_VOZ_TEMPO_REAL
    },
    // A IA está com a resposta tocando agora — usado só pra decidir o ÍCONE
    // do botão de enviar/iniciar-voz (ver `iconeDoBotaoEnviar`); clicar nele
    // já interrompe a fala dela por conta do próprio `iniciar()` do motor.
    estaFalando() {
      return this.estadoDaFala === 'ia'
    },
    // Mirror de `canSend`, sem o `!loading`: decide quando o mic aparece no
    // lugar do enviar — ele deve sumir assim que há texto, mesmo com um
    // envio ainda em andamento (o botão de enviar/parar já cobre esse caso).
    temTexto() {
      return Boolean(String(this.value || '').trim())
    },
    // [feedback do usuário, 04/09 — 5ª rodada] "o placeholder vira
    // 'Escutando...'" — só no Modo de Voz (Ditar já mostra o texto ao vivo
    // por cima, então o placeholder normal nem chega a aparecer ali).
    placeholderEfetivo() {
      if (this.gravando && this.modoDeVoz) return COPY_VOZ.escutando
      return this.placeholderDoAtalhoSelecionado || this.placeholder
    },
    rotulosDeVoz() {
      return COPY_VOZ
    },
    rotuloMutar() {
      return this.microfoneMutado
        ? COPY_VOZ.reativarMicrofone
        : COPY_VOZ.mutarMicrofone
    },
    /**
     * O que vem DEPOIS da barra, quando o campo começa com ela — é o que filtra
     * o menu de ferramentas. Vazio enquanto só a `/` foi digitada, e vazio
     * também quando a barra está no meio do texto (aí não é comando).
     *
     * ⚠️ [spec-013 T003] SÓ o primeiro TOKEN, não a frase inteira. Um atalho
     * com argumento livre (`/pré-reunião Marcelo Pontes`) tinha o item
     * apagado do menu: `comandosFiltrados`/`modulosFiltrados`
     * (`composer-ferramentas.vue`) casam por PREFIXO contra o rótulo, e
     * "pré-reunião marcelo pontes" não é prefixo de "pré-reunião" — o menu
     * esvaziava assim que o segundo caractere do argumento era digitado.
     * Alteração cirúrgica desta task em `send-message.vue`: só esta função.
     */
    filtroDeFerramentas() {
      const valor = String(this.value || '')
      if (valor.indexOf(COMANDO_DE_FERRAMENTAS) !== 0) return ''
      const resto = valor.slice(COMANDO_DE_FERRAMENTAS.length)
      const indiceDoEspaco = resto.indexOf(' ')
      return indiceDoEspaco === -1 ? resto : resto.slice(0, indiceDoEspaco)
    },
    // Menu aberto pela `/`, e não pelo "+" — é o que faz a lista mostrar os
    // comandos. Não dá para inferir do `filtroDeFerramentas`: ele é vazio nos
    // dois casos enquanto nada foi digitado depois da barra.
    emModoComando() {
      const valor = String(this.value || '')
      return valor.indexOf(COMANDO_DE_FERRAMENTAS) === 0
    },
    rotuloRemoverFerramenta() {
      if (!this.ferramentaAtiva) return ''
      return 'Remover ' + this.ferramentaAtiva.rotulo
    },
    temFerramentas() {
      return this.ferramentas.length > 0
    },
    // O modo limpo tira o seletor de modelo para a fileira caber numa linha.
    // Reusa o gate que já existe em vez de um caminho novo — e, como ele,
    // derruba o TRIO: modelo, hint de modelo e o toggle de raciocínio.
    modeloOculto() {
      return this.hideModelSelect || this.estiloLimpo
    },
    // `estiloLimpo` é proxy exato da `/ia` — nenhuma outra superfície passa a
    // prop, e ela coincide com o gate de rota do próprio palette.
    usarPaletteNosChips() {
      return this.estiloLimpo
    },
    // ★ Acesso DINÂMICO em vez de mapState/mapGetters: os helpers do Vuex fixam o
    // namespace no momento da definição do componente, e este é reusado pela Central
    // de IA sob outro `storeModule` (spec-003 §5). Com o namespace fixo, ela leria o
    // state do IA CRM. No default as strings resolvidas são idênticas às de antes.
    storeState() {
      return this.$store.state[this.storeModule] || {}
    },
    selectedModel() {
      return this.storeState.selectedModel
    },
    // spec-016 [T004] — mesmo acesso dinâmico de `selectedModel`; só
    // resolve de verdade quando `storeModule` é `aawz-intelligence-v2` (o
    // único namespace com essa chave — `mostrarSeletorDeVoz` garante que
    // ninguém mais lê/despacha aqui).
    vozSelecionada() {
      return this.storeState.vozSelecionada || ''
    },
    supportedModels() {
      return this.storeState.supportedModels || []
    },
    // Pré-computado: chamada de função no template reexecuta a cada render.
    rotuloDoRaciocinio() {
      return this.thinkingEnabled
        ? COMPOSER_CHAT.raciocinioLigado
        : COMPOSER_CHAT.raciocinioDesligado
    },
    thinkingEnabled() {
      return this.storeState.thinkingEnabled
    },
    currentModelMeta() {
      return this.$store.getters[this.storeModule + '/currentModelMeta']
    },
    // [bug corrigido, feedback do usuário] Só texto travava anexo-sem-texto:
    // a pessoa anexava a planilha, não digitava nada, e o botão de enviar
    // ficava preso — mesmo com `onSend` já mandando `arquivos` corretamente.
    // Texto OU anexo já libera (a fila do turno é o que `onSend` esvazia).
    // ★ Sem texto, só anexo PRONTO libera: um item só `erro`/`sem_cliente`/
    // `enviando` não tem nada para mandar SOZINHO, e o envio vazio esvaziava
    // a fila em silêncio.
    // ★ [spec-009-anexo-sem-trava, T010, 20/09/2026 — REVERTE o de 17/09]
    // `canSend` deixou de olhar o STATUS do anexo (D6 do plano): nem
    // `existeAnexoNaoEnviado` (`sem_cliente`/`erro`), nem um upload ainda
    // `enviando`. US-2: "o envio NUNCA é bloqueado por anexo" — o que muda
    // por arquivo é só SE ELE VAI JUNTO (pronto vai; o resto fica na fila e
    // é dito no turno, ver `textoDoEnvio`/`onSend`). Um anexo em `erro`, ou
    // ainda subindo, com TEXTO digitado, não pode mais travar a mensagem
    // inteira — foi exatamente esse bloqueio que travou o envio do CTO
    // (print: `/fee-fixo` + PDF de prospect, "Algum anexo não subiu — remova
    // no × para enviar").
    // ★ [T014/T015, W6, 20/09/2026] A ÚLTIMA trava de anexo caiu junto: o
    // `if (this.atalhoDescartariaAnexo) return false` que morava aqui. O
    // atalho continua sem levar o anexo (turno SEM MODELO — não há quem o
    // leia), mas agora ele PARTE e o anexo FICA na fila para o turno
    // seguinte, com o composer dizendo isso (`avisoDeAnexo` →
    // `COMPOSER_CHAT.atalhoNaoLevaAnexo`). Nenhum status de anexo, e nenhuma
    // combinação de anexo com atalho, bloqueia mais o envio.
    canSend() {
      if (this.envioBloqueado) return false
      const trimmed = (this.value || '').trim()
      // Atalho em chip despacha mesmo sem argumento — quem pede o cliente é o servidor.
      const temConteudo =
        trimmed.length > 0 ||
        this.temAnexoPronto ||
        Boolean(this.atalhoSelecionado)
      return temConteudo && !this.loading
    },
    modelOptions() {
      const models = this.supportedModels || []
      return models.map(function (m) {
        return { value: m.id, text: m.label }
      })
    },
    modelSelectDisabled() {
      return this.loading || this.modelLocked
    },
    // Streaming e conversa travada bloqueiam o chip pelos mesmos dois motivos
    // que bloqueiam o seletor de modelo.
    agentSelectDisabled() {
      return this.loading || this.agenteTravado
    },
    // Sem o chip na tela, o hint sobre ele seria uma frase órfã.
    mostraEscopoFixo() {
      return this.escopoDeCliente && this.escopoTravado
    },
    mostraAgenteFixo() {
      return this.showAgentSelect && this.agenteTravado
    },
    // Mesma razão do agente: com o cluster de modelo escondido (G5) o parceiro
    // não escolhe modelo, então não há trava para anunciar.
    mostraModeloFixo() {
      return !this.modeloOculto && this.modelLocked
    },
    // Label do modelo selecionado no trigger do dropdown. Sem lista ainda, cai
    // no id cru e, sem id nenhum, no substantivo neutro — o store não nasce
    // mais com um id literal que pode ter saído do catálogo (Q7-A08).
    modelTriggerLabel() {
      const current = this.modelOptions.find(
        (m) => m.value === this.selectedModel
      )
      return (
        (current && current.text) ||
        this.selectedModel ||
        COMPOSER_CHAT.modeloIndefinido
      )
    },
    // Options no shape do ComposerInlineSelect. Sem ícone por item — a marca
    // "W" foi removida do seletor de modelo (risco jurídico), só o check no
    // item selecionado indica o modelo ativo.
    modelSelectOptions() {
      return this.modelOptions.map((m) => ({
        label: m.text,
        active: m.value === this.selectedModel,
        disabled: this.modelSelectDisabled,
        onClick: () => this.onModelChange(m.value),
      }))
    },
    showThinkingToggle() {
      const meta = this.currentModelMeta
      return !!(meta && meta.provider === 'opencode_go')
    },
    // O chip ficou do lado oposto do seletor de modelo na barra, então precisa
    // carregar sozinho o mesmo guard de G5 que o `<template>` comum dava aos dois.
    mostraThinkingToggle() {
      return !this.modeloOculto && this.showThinkingToggle
    },
    // ★ Era `return true` fixo, pelo gap G3: um "+" que aceita arquivo e um
    // envio que o descarta em SILÊNCIO é dado falso pela via contrária
    // (§9.2/C10). O gap continua aberto — o `POST /chat` não tem campo de
    // arquivo —, mas o silêncio não: com o anexo liberado a faixa DIZ na tela
    // que ele não vai para a IA (ver `avisoDeAnexo`). É o que permite exercitar
    // a UI sem prometer o que não existe.
    anexosDesabilitados() {
      return !this.anexosLiberados
    },
    // ⚠️ Este comentário dizia que o aviso era pré-requisito do envio. Não é
    // mais, desde a spec-009 (T010/T014): `canSend` não consulta `avisoDeAnexo`,
    // e `envioBloqueado` é prop de CRÉDITOS, não de anexo. O aviso hoje é
    // informativo — diz o que não vai junto, e o turno parte assim mesmo. Era o
    // pedido do CTO, verbatim: *"nunca bloquear"*.
    temAnexos() {
      return this.arquivos.length > 0
    },
    // Upload concluído com `uploadId` — o único anexo que o corpo do POST leva.
    temAnexoPronto() {
      return this.anexosProntos.length > 0
    },
    // ★ [spec-016 T023] O upload REAL existe agora — o aviso não é mais
    // incondicional (ver `constants/Anexos.js`/`send-message-anexos-upload-
    // mixin.js` para a limitação medida: só sobe com `idClienteAnexo`). Só
    // aparece quando SOBRA algum anexo sem `upload_id` de fato — 'enviando'
    // não conta (é transitório, o spinner na miniatura já avisa).
    avisoDeAnexo() {
      if (!this.anexosLiberados) return ''
      // ★ [T014, W6] Quem não leva o anexo é o TURNO DE ATALHO, qualquer que
      // seja o status do arquivo — por isso vem antes dos outros dois avisos:
      // com um atalho ativo, nem o anexo pronto vai. Aviso informativo, não
      // trava (`canSend` não o consulta mais): o turno parte e o anexo fica.
      if (this.atalhoNaoLevaAnexo) return COMPOSER_CHAT.atalhoNaoLevaAnexo
      if (!this.existeAnexoNaoEnviado) return ''
      if (this.existeAnexoSemCliente) return COMPOSER_CHAT.anexoSemCliente
      return COMPOSER_CHAT.anexosNaoEnviados
    },
    /**
     * ★ teste-11 (09/09/2026) — para QUEM vai a carteira anexada.
     *
     * A frase aparece enquanto houver anexo na fila E um cliente resolvido:
     * é o único momento em que o consultor ainda pode desfazer. Sem cliente
     * o `avisoDeAnexo` acima já diz o que fazer, e as duas juntas seriam
     * ruído — por isso esta cede a vez (`existeAnexoSemCliente`).
     *
     * Sem `nomeClienteAnexo` (o id resolveu, o nome não veio) a frase NÃO é
     * montada: "vai para " é pior que silêncio, e um id cru na tela não diz
     * ao consultor de quem é o cadastro.
     */
    destinoDoAnexo() {
      if (!this.temAnexos) return ''
      if (this.existeAnexoSemCliente) return ''
      if (!this.idClienteAnexo || !this.nomeClienteAnexo) return ''
      return COMPOSER_CHAT.destinoDoAnexo.replace(
        '{cliente}',
        this.nomeClienteAnexo
      )
    },
    // ⚠️ O rótulo segue a TRAVA, não é fixo. Ele aparece na descrição da linha
    // do "+" e no tooltip do botão: com o anexo liberado, "Anexos em breve" ali
    // seria mentira — e é justamente onde a pessoa olha antes de clicar.
    rotuloAnexos() {
      if (this.anexosDesabilitados) return COMPOSER_CHAT.anexosEmBreve
      return COMPOSER_CHAT.anexosAceitos
    },
    // Um hint só (e um cadeado só) para os dois locks: eles ficam colados aos
    // seletores que travam, e o texto tem de dizer exatamente qual deles caiu.
    // String vazia é o quarto estado — nada travado, hint não renderiza.
    rotuloTravaConversa() {
      // Os três caem JUNTOS (a mesma conversa com histórico trava os três), e
      // por isso a frase genérica cobre o caso comum sem enumerar ninguém.
      // As específicas seguem para as superfícies que escondem um dos chips —
      // o parceiro não vê modelo (G5), e nem toda tela tem escopo de cliente.
      const travados = [
        this.mostraAgenteFixo,
        this.mostraModeloFixo,
        this.mostraEscopoFixo,
      ].filter(Boolean).length
      if (travados > 1) return COMPOSER_CHAT.fixosNaConversa
      if (this.mostraAgenteFixo) return COMPOSER_CHAT.agenteFixo
      if (this.mostraModeloFixo) return COMPOSER_CHAT.modeloFixo
      if (this.mostraEscopoFixo) return COMPOSER_CHAT.escopoFixo
      return ''
    },
    // [feedback do usuário, 04/09 — pivô ChatGPT] Campo vazio e parado: o
    // botão de enviar vira o gatilho do Modo de Voz ("botao de enviar na
    // verdade vira aqeuel com icone de iniciar voz"). Some assim que há
    // texto, um anexo na fila (a seta é o único jeito de mandá-lo sem texto)
    // ou um envio em andamento (`loading` já tem o botão de parar).
    // Sem créditos (`envioBloqueado`) a bolha NÃO vira o Modo de Voz: o modo
    // ENVIA sozinho ao fim de cada fala — abrir a gravação seria oferecer um
    // envio que o gate vai recusar (achado ao vivo, 14/09/2026). O Ditar
    // continua livre: só preenche o campo.
    mostraIniciarVoz() {
      if (this.envioBloqueado) return false
      // Chip de comando na caixa já é conteúdo a enviar (o atalho despacha sem
      // argumento): o botão precisa ser o de enviar, não o do Modo de Voz.
      if (this.chipDoComposer) return false
      return !this.temTexto && !this.temAnexos && !this.loading
    },
    iconeDoBotaoEnviar() {
      // [feedback do usuário, 04/09] "não fica claro, o botão poderia virar
      // com aquele ícone de parar" — enquanto a IA fala, o mesmo botão que
      // inicia o Modo de Voz sinaliza "toque pra pará-la" em vez de
      // "iniciar", mesmo clique (`aoClicarEnviar` → `iniciarVoz` → o motor
      // já interrompe a fala dela).
      if (this.mostraIniciarVoz)
        return this.estaFalando ? 'stop' : 'audio-lines'
      return this.loading ? 'stop' : 'arrow-up-line'
    },
    // ★ [17/09/2026] Com o envio travado por um anexo que não pode subir, o
    // rótulo É o aviso: ele vira o `title` (o tooltip do botão desabilitado) e
    // o `aria-label`. Botão apagado sem motivo legível ao passar o mouse era
    // metade do defeito medido — a pessoa via o aviso embaixo do campo e o
    // botão morto, sem ligar um ao outro.
    rotuloBotaoAcao() {
      if (this.loading) return COMPOSER_CHAT.cancelar
      if (this.mostraIniciarVoz) {
        return this.estaFalando ? COPY_VOZ.pararIa : COPY_VOZ.iniciarVoz
      }
      // ★ [T010/T014] O aviso não trava mais NADA (nem anexo sem subir, nem
      // atalho com anexo na fila): ele diz, no `title`/`aria-label` do botão
      // habilitado, o que vai acontecer com o arquivo quando o turno partir.
      if (this.avisoDeAnexo) return this.avisoDeAnexo
      return COMPOSER_CHAT.enviar
    },
    // `px-4` alinha a caixa com o `padding: 32px 16px` do `.messages__trilho`
    // no estado COM mensagens — ver a nota em `_ia-chat-trilho.sass`. No herói
    // não existe esse padding em nenhum irmão: o título e os chips começam em
    // x=0 da coluna, e os mesmos 16px empurravam só a caixa para a direita.
    // Medido contra o protótipo: lá título, composer e chips partem todos de x=48.
    // A cor da marca só aparece quando dá para enviar: em repouso o botão é um
    // alvo neutro, e o preenchimento vira o sinal de "pronto". --primary e
    // --text-on-primary são derivados por escritório (white-label), como o
    // avatar do painel.
    classesEnviar() {
      if (this.loading) return 'send-message-enviar--parar'
      if (this.mostraIniciarVoz) return 'send-message-enviar--iniciar-voz'
      return this.canSend ? 'send-message-enviar--pronto' : ''
    },
    // O pulso é uma classe A MAIS, nunca a substituição da variante: o botão
    // continua sendo o "pronto" (preenchido) enquanto pulsa.
    classesDoBotaoEnviar() {
      return [this.classesEnviar, { 'az-highlight-pulse': this.pulsarEnvio }]
    },
    estiloDoPulsoDeEnvio() {
      if (!this.duracaoDoPulsoDeEnvio) return null
      return { '--az-pulse-duration': this.duracaoDoPulsoDeEnvio }
    },
    corDoBotaoEnviar() {
      if (this.loading) return 'var(--danger-text)'
      if (this.mostraIniciarVoz) return 'var(--text-on-primary)'
      return this.canSend ? 'var(--text-on-primary)' : 'var(--neutral-700)'
    },
    classesWrapper() {
      return this.large ? 'px-0' : 'px-4'
    },
    classesCaixa() {
      // ⚠️ As utilitárias do Vuetify entram por AQUI, e não fixas na `class`,
      // porque o modo limpo precisa NÃO tê-las: `flex-column` é
      // `flex-direction: column !important` e empilhava a fileira inteira —
      // "+", campo, ícones e enviar, um sob o outro. `pa-3` e o gap vêm no
      // mesmo pacote e também não servem à linha fina.
      return {
        'd-flex flex-column az-gap-xsmall pa-3': !this.estiloLimpo,
        'send-message-inner--large': this.large,
        'send-message-inner--limpo': this.estiloLimpo,
        'send-message-inner--animando': this.animandoAltura,
        // Duas fileiras: só no modo limpo, e só depois que o campo passa de uma
        // linha. É o que põe a barra de rolagem na borda direita da caixa —
        // com os botões ao lado do campo, ela nunca alcança a borda.
        'send-message-inner--multilinha': this.estiloLimpo && this.multiLinha,
        // ⚠️ Sem isto a faixa de anexos entra NA fileira de controles: a caixa
        // do modo limpo é uma linha só (`flex-wrap: nowrap`), e miniatura,
        // chip e aviso viravam itens de flex ao lado do "+" e do campo.
        'send-message-inner--com-anexos': this.estiloLimpo && this.temAnexos,
        'send-message-inner--arrastando': this.arrastando,
      }
    },
    // Uma linha só no rodapé: com o disclaimer ligado ele SUBSTITUI a dica de
    // teclado (é o que o protótipo mostra), em vez de empilhar as duas.
    //
    // [spec-013 T016] O disclaimer regulatório (S4) nunca cede lugar — só a
    // dica de teclado, que é puramente cosmética, é substituída pela dica de
    // argumento de um atalho ativo (`dicaDeArgumentoDoAtalho`, mixin de
    // atalhos aninhado via `sendMessageCatalogoComandosMixin`): é assim que
    // `placeholderArgumento` (`/pré-reunião` → "nome do cliente") chega à
    // tela. O `:placeholder` nativo do campo (`placeholderEfetivo`, acima)
    // não serve para isto — só aparece com o campo VAZIO, e o atalho ativo
    // por definição tem `/algo` digitado nele.
    textoRodape() {
      if (!this.hideDisclaimer) return COMPOSER_CHAT.disclaimer
      if (this.dicaDeArgumentoDoAtalho) return this.dicaDeArgumentoDoAtalho
      return this.semDicaDeTeclado ? '' : DICA_TECLADO
    },
  },
  watch: {
    /**
     * [feedback do usuário, 04/09] Esc cancela a gravação em andamento.
     *
     * ⚠️ NO `document`, não no `onKeydown` de `$el`: o botão que inicia a
     * gravação (a opção do menu do mic) É REMOVIDO do DOM assim que clicado
     * (o `v-if`/`v-else-if` troca de ramo), e o foco cai pra `document.body`
     * — fora da subtree de `$el`, onde o listener de `onKeydown` está preso.
     * Medido ao vivo: sem isto, o Esc não cancelava nada. Mesmo padrão do
     * `open` watcher em `composer-inline-select.vue` (liga só enquanto
     * precisa, desliga ao sair do estado).
     *
     * ⚠️ [bug corrigido, 04/09 — motor-de-voz] `immediate: true` é
     * OBRIGATÓRIO desde que `gravando` passou a ler `motorDeVoz` (fora
     * desta instância): o rodapé pode MONTAR já com `gravando: true` (o
     * Modo de Voz iniciado no herói expandindo a tela — ver
     * `vozExpandeParaRodape` em `view-chat.vue`), e um watcher não-imediato
     * só dispara em MUDANÇA — sem `immediate`, essa instância nasceria
     * gravando e o Esc simplesmente não cancelaria nada nela.
     */
    gravando: {
      immediate: true,
      handler(gravandoAgora) {
        if (gravandoAgora) {
          document.addEventListener('keydown', this.onDocumentKeydownEsc, true)
        } else {
          document.removeEventListener(
            'keydown',
            this.onDocumentKeydownEsc,
            true
          )
        }
      },
    },
  },
  mounted() {
    // O guard existe porque o slice `chat` do ai-framework não tem `supportedModels`
    // nem a action que a carrega — o parceiro nunca escolhe modelo (RF2.6/NC-3).
    //
    // ⚠️ `hideModelSelect`, e NÃO `modeloOculto`. Com `modeloOculto` a `/ia`
    // entrava aqui pelo `estiloLimpo` e a lista NUNCA era carregada — o palette
    // abria a seção de modelos vazia, tanto pelo `/modelo` quanto pelo Ctrl+K.
    // O chip não caber na fileira é layout; não escolher modelo é o parceiro.
    if (!this.hideModelSelect) {
      // O namespace viaja como payload: com conversa viva o slice é um clone,
      // e a action precisa saber ONDE gravar (ver `store/actions.js`).
      this.$store.dispatch(
        this.storeModule + '/loadSupportedModels',
        this.storeModule
      )
    }
    // spec-016 [T004] — só quando o consumidor liga o seletor de voz (a
    // `/ia`); `apiVoz.catalogo()` já cacheia em memória, então herói/rodapé
    // (que montam/desmontam a toda hora) não repetem o `GET /voz/vozes`.
    if (this.mostrarSeletorDeVoz) this.carregarCatalogoDeVozes()
    // O v-textarea do Vuetify chama stopPropagation() em TODO Enter (VTextarea.onKeyDown,
    // "prevents closing of a dialog when pressing enter"), então um listener na fase de
    // bubble (@keydown.native) no <input-by-type> nunca recebe o evento. Anexar na fase de
    // CAPTURA, que roda antes do evento alcançar o <textarea> e o stopPropagation() agir.
    this.$el.addEventListener('keydown', this.onKeydown, true)
    if (this.focarAoMontar) this.focarCampo()
    // Registra ESTA instância como quem recebe o resultado da gravação
    // (`motor-de-voz.js`). É reatribuído a cada montagem — herói e rodapé se
    // alternam, e quem está NA TELA é sempre quem deve receber o texto.
    //
    // ★ [spec-008 T030c] O MESMO destino serve os DOIS transportes. As duas
    // metades são disjuntas em nome e cada transporte só chama o que conhece
    // (`if (!_destino[evento]) return`, nos dois) — um destino por transporte
    // obrigaria este componente a saber qual está no comando, que é
    // exatamente o que o contrato proíbe ("`nome` NUNCA é lido por componente
    // de tela", US-3 AC3). A política dos oito eventos novos mora em
    // `utils/destino-de-voz-tempo-real.js`; aqui ficam só os ganchos que
    // exigem DOM ou navegação.
    this._destinoDoMotor = {
      aoPreencherTexto: (texto) => this.$emit('input', texto),
      aoEnviarVoz: (texto) => this.$emit('enviar-voz', texto),
      avisarErroDeTranscricao: (r) => {
        this.$showSnack(r || { message: COPY_VOZ.erroTranscricao })
      },
      focarCampo: () => this.focarCampo(),
      ...criarDestinoDeVozTempoReal({
        anexarAudio: (fluxo) => this.anexarAudioDaVoz(fluxo),
        avisar: (mensagem) =>
          this.$showSnack({ text: mensagem, color: 'error', button: true }),
        encerrarVoz: () => this.sairDoModoDeVoz(),
        cairParaPorTurnos: () => this.cairParaVozPorTurnos(),
        mensagemDeQueda: MENSAGEM_QUEDA_PARA_POR_TURNOS,
      }),
    }
    registrarDestino(this._destinoDoMotor)
    // ★ [T030c] A instância que monta NO MEIO de uma sessão em tempo real
    // re-anexa a trilha viva. O `<audio>` morre com a instância anterior, e o
    // `audioRemoto` só é emitido UMA vez por sessão (no `ontrack`): sem esta
    // linha a IA emudeceria no instante em que o Modo de Voz expande o herói
    // para o rodapé — o primeiro gesto da conversa.
    this.anexarAudioDaVoz(fluxoRemotoAtual())
  },
  beforeDestroy() {
    this.$el.removeEventListener('keydown', this.onKeydown, true)
    // Cinto e suspensório: se o componente for destruído NO MEIO de uma
    // gravação, o watcher de `gravando` não dispara mais (o componente já
    // está saindo) — remove aqui também, senão o listener do `document`
    // vazaria por cima da vida do componente.
    document.removeEventListener('keydown', this.onDocumentKeydownEsc, true)
    // ⚠️ NÃO para a gravação aqui — é exatamente o que `motor-de-voz.js`
    // existe para evitar. Herói e rodapé são instâncias DIFERENTES deste
    // componente, alternadas por `v-if` (ver `view-chat.vue`); destruir esta
    // instância no meio de uma gravação (por exemplo, o Modo de Voz
    // expandindo o layout do herói pro rodapé) não pode interrompê-la — o
    // motor sobrevive à troca, e a próxima instância montada se
    // re-registra como destino no `mounted()` dela.
    desregistrarDestino(this._destinoDoMotor)
  },
  methods: {
    /**
     * `Backspace`/`Delete` com o campo VAZIO remove o chip da ferramenta.
     *
     * É o gesto do ChatGPT: o bloco some inteiro, não caractere a caractere.
     * Só com o campo vazio — senão apagar a última letra da frase levaria a
     * ferramenta junto, que é o oposto do esperado.
     */
    aoApagar() {
      if (this.value) return
      // O chip mais recente sai primeiro: o atalho fica por cima do módulo.
      if (this.atalhoSelecionado) return this.limparAtalhoSelecionado()
      if (!this.ferramentaAtiva) return
      this.$emit('limpar-ferramenta')
    },
    onInput(val) {
      // Antes de qualquer `$nextTick`: aqui o DOM ainda é o de antes da tecla,
      // que é o ponto de partida da animação.
      const caixa = this.$refs.caixa
      this.alturaDaCaixaAntes = caixa ? caixa.offsetHeight : 0
      this.$emit('input', val)
      this.reagirAoComando(val)
      this.medirAltura()
    },
    onSend() {
      if (!this.canSend) return
      // Atalho de negócio digitado/escolhido (`/panorama`, `/pré-reunião X`):
      // despacha o turno do atalho em vez de `send` (mixin de atalhos).
      if (this.despacharAtalhoDigitado()) return
      // ⚠️ Segundo argumento, e não um objeto no lugar do primeiro: o `@send`
      // tem quatro consumidores (popup, painel do Hub, Fee-Based, ai-framework)
      // e todos leem o texto na primeira posição. Quem não conhece os anexos
      // simplesmente ignora o argumento a mais.
      //
      // ★ [spec-016 T023] Terceiro argumento — `anexosProntos` (mixin de
      // upload): só os uploads que TERMINARAM com sucesso, prontos para o
      // corpo do POST (`{uploadId, nome, contentType, tamanho}`). Mesma regra
      // do segundo argumento: quem não sabe de anexo real (os 4 consumidores
      // acima) ignora e continua igual.
      //
      // ★ [T009, spec-009, 20/09/2026 — REVERTE o de 17/09] Os dois
      // argumentos de anexo NÃO descrevem mais a MESMA fila: com `canSend`
      // sem olhar status (T010), a fila pode ter item `enviando`/`erro`/
      // `sem_cliente` no instante do clique. `anexosDaBolha` (mixin) é só o
      // que TERMINOU com sucesso — o mesmo conjunto de `anexosDaRede`, com o
      // `File` cru em vez do metadado do upload — para a bolha nunca mostrar
      // um cartão sem `upload_id`. O que ficou de fora é dito no TEXTO
      // (`itensNaoIncluidosNoEnvio`) e preservado na fila
      // (`removerAnexosEnviados`, abaixo) — nada desaparece em silêncio.
      const anexosDaRede = this.anexosProntos.slice()
      const anexosDaBolha = this.arquivosEnviaveis.slice()
      const itensNaoIncluidos = this.itensNaoIncluidosNoEnvio
      this.$emit(
        'send',
        this.textoDoEnvio(anexosDaRede, itensNaoIncluidos),
        anexosDaBolha,
        anexosDaRede
      )
      // O comando do módulo foi com a fala; a caixa volta limpa, chip incluído.
      if (this.ferramentaAtiva) this.$emit('limpar-ferramenta')
      // ★ [T009] A fila é do TURNO só para quem FOI: o que ficou de fora
      // (mencionado no texto acima) continua esperando o próximo envio —
      // `removerAnexosEnviados` (mixin) tira só os `enviado`.
      this.removerAnexosEnviados()
    },
    // Envio só com anexo: os consumidores do `@send` descartam texto vazio
    // antes de qualquer `await`, então o turno leva uma frase própria para o
    // anexo não sumir. ⚠️ O comentário citava `_dispararContinuacaoDeAnexos`,
    // que NÃO existe mais — o turno de continuação automático caiu junto com a
    // sua causa (ver "O que caiu junto com a causa" no CLAUDE.md do módulo).
    // A frase continua sendo a mesma copy, agora sem disparo automático atrás.
    //
    // ★ [T009, spec-009] `itensNaoIncluidos` ([{nome, motivo}]) vira uma
    // frase própria, ANEXADA ao texto do turno — nunca substitui: o que a
    // pessoa escreveu (ou a continuação de anexo, sem texto) sempre parte,
    // e quem ficou de fora é dito ao lado, nunca em silêncio.
    textoDoEnvio(anexosDaRede, itensNaoIncluidos) {
      const partes = []
      if ((this.value || '').trim()) {
        partes.push(this.comComandoDoModulo(this.value))
      } else if (anexosDaRede.length) {
        partes.push(
          COMPOSER_CHAT.continuacaoDeAnexos(anexosDaRede.map((anexo) => anexo.nome))
        )
      }
      if (itensNaoIncluidos && itensNaoIncluidos.length) {
        partes.push(COMPOSER_CHAT.anexosNaoIncluidos(itensNaoIncluidos))
      }
      return partes.join('\n\n')
    },
    onAbort() {
      this.$emit('abort')
    },
    onKeydown(event) {
      // Enter sozinho envia; Shift+Enter quebra linha (comportamento default do textarea)
      // Guarda de IME (spec-007 R6, do #1961): durante composição — acento,
      // kanji, sugestão do teclado mobile — o Enter CONFIRMA o texto, não
      // envia. Sem isto a mensagem partia no meio da palavra.
      if (event.isComposing || event.keyCode === 229) return
      // ⚠️ Dentro de um menu, o Enter é do ITEM focado, não do composer. Este
      // handler roda na fase de CAPTURA do `$el` (ver `mounted`), e o menu do
      // "+" e o do agente renderizam DENTRO dele — sem esta guarda o Enter era
      // engolido aqui (o `preventDefault` matava a ativação nativa do <button>)
      // e ainda mandava a mensagem em vez de escolher a opção.
      if (this.emMenu(event.target)) return
      this.tratarSelecionarTudoComChip(event)
      this.tratarCopiarChipSemTexto(event)
      // Antes do `descer-para-acoes`: o ↓ só é do histórico enquanto se navega nele.
      if (this.tratarSetaDoHistorico(event)) return
      if (event.key === 'ArrowDown' && this.podeDescerDoCampo(event.target)) {
        event.preventDefault()
        this.$emit('descer-para-acoes')
        return
      }
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault()
        this.onSend()
      }
    },
    /**
     * A seta para baixo só SAI do campo com o cursor no fim do texto.
     *
     * O campo é `auto-grow` e Shift+Enter cria linhas: roubar a seta sempre
     * quebraria a edição multi-linha. No fim do texto não há para onde descer
     * dentro dele, e aí a tecla fica livre para levar às ações abaixo.
     *
     * ⚠️ Sem seleção ativa (`selectionStart === selectionEnd`): com trecho
     * selecionado a seta colapsa a seleção, que é o que o usuário espera.
     */
    podeDescerDoCampo(alvo) {
      if (!alvo || alvo.tagName !== 'TEXTAREA') return false
      const fim = String(alvo.value || '').length
      return alvo.selectionStart === fim && alvo.selectionEnd === fim
    },
    // `role="menu"` é o que o painel do `composer-inline-select` declara.
    emMenu(alvo) {
      return Boolean(alvo && alvo.closest && alvo.closest('[role="menu"]'))
    },
    /**
     * `/` no início do campo abre o menu de ferramentas, e o que vem DEPOIS
     * dela filtra a lista — `/crm` deixa só o CRM.
     *
     * ⚠️ A barra NÃO é interceptada: ela é digitada normalmente e continua no
     * campo. Ela é o comando visível, como no ChatGPT e no Claude — engolir o
     * caractere deixaria o usuário sem entender por que o menu abriu.
     *
     * Só vale no INÍCIO: barra é caractere legítimo no meio de uma pergunta
     * ("fundos 60/40", "resultado 1/3"), e abrir o menu ali roubaria a digitação.
     */
    reagirAoComando(valor) {
      if (!this.temFerramentas) return

      const menu = this.$refs.ferramentas
      if (!menu) return

      // Atalho já em CHIP: o menu não tem mais o que oferecer — fica fechado,
      // e uma `/` dentro do argumento é texto.
      if (this.atalhoSelecionado) {
        menu.fechar()
        return
      }
      // ★ [merge release/ia-claude-code, 20/09] A release guardava também um
      // `esperandoArgumento` que lia `this.atalhoAtivo` — membro que NÃO existe
      // neste componente (nem lá), então a expressão era sempre `undefined` e a
      // guarda nunca disparava. O caso que ela queria cobrir (atalho digitado
      // com argumento, ainda sem chip) é exatamente o que `ehAtalhoDeNegocio`
      // abaixo resolve de fato: `/pré-reunião João` é atalho, o menu não abre e
      // cai no `else menu.fechar()`.
      const ehBarra = String(valor || '').indexOf(COMANDO_DE_FERRAMENTAS) === 0
      // `false` = sem roubar o foco: a pessoa está digitando o comando.
      if (ehBarra && !this.ehAtalhoDeNegocio(valor)) menu.abrir(false)
      else menu.fechar()
    },
    /**
     * O texto é um ATALHO de negócio que a tela oferece? (G-2 do QA)
     *
     * Enquanto for, o menu de ferramentas fica FECHADO: ele não conhece
     * atalho nenhum e anunciaria "Nenhuma ferramenta com esse nome" em cima
     * de um comando válido — foi assim que a tela, no QA de 19/09/2026,
     * desmentiu a instrução que o próprio servidor tinha acabado de dar
     * ("mande /pré-reunião com o nome do cliente").
     *
     * A mesma função pura que o pai usa para DESPACHAR
     * (`utils/atalho-digitado.js`): duas leituras do que conta como atalho
     * digitado divergiriam, e o sintoma seria o menu discordar do envio.
     */
    ehAtalhoDeNegocio(valor) {
      return Boolean(atalhoDigitado(valor, this.atalhosDeNegocio))
    },
    onModelChange(newModel) {
      this.$store.dispatch(this.storeModule + '/setSelectedModel', newModel)
      this.$emit('change-model', newModel)
    },
    // spec-016 [T004] — carrega o catálogo curado (US-2 AC3). `apiVoz.catalogo()`
    // já cacheia em memória (ver comentário do módulo); falha de rede aqui só
    // deixa a lista vazia, e o chip nem monta (`temVozes` do componente).
    //
    // [G-2, review spec-016, 10/09/2026] RECONCILIA a voz salva no
    // localStorage com o catálogo recém-carregado — mesmo padrão de
    // `loadSupportedModels` (store/actions.js), que reescreve o valor
    // obsoleto assim que a lista chega do servidor. Sem isso, quem escolheu
    // uma voz que o owner tirou do catálogo (Neutra/Marina/Jorge, trocadas
    // em 09/09/2026) continua mandando esse id em TODA frase da fala
    // progressiva: o consultor ouve a voz padrão, o chip mostra o rótulo
    // genérico "Voz" (porque `vozAtiva` não casa com nenhum item da lista),
    // e o servidor loga um WARNING de "voice_id fora do catálogo" por frase
    // sintetizada — o log que o fail-closed (ADR-016-01) existe para
    // detectar pedido FORJADO, afogado aqui por tráfego legítimo.
    // `setVozSelecionada('')` é a MESMA action que `aoTrocarVoz` já usa: o
    // IO de commit + localStorage continua morando só nela.
    async carregarCatalogoDeVozes() {
      const r = await apiVoz.catalogo()
      if (r && r.status === 200 && r.value) {
        this.catalogoDeVozes = r.value.vozes || []

        const idsDoCatalogo = this.catalogoDeVozes.map((voz) => voz.id)
        if (
          this.vozSelecionada &&
          !idsDoCatalogo.includes(this.vozSelecionada)
        ) {
          this.$store.dispatch(this.storeModule + '/setVozSelecionada', '')
        }
      }
    },
    aoTrocarVoz(vozId) {
      this.$store.dispatch(this.storeModule + '/setVozSelecionada', vozId)
    },
    /**
     * "Ouvir antes de fixar" (US-3). `apiVoz.amostra` + `tocarAmostra` — NUNCA
     * o caminho da fala da conversa (`fala-da-ia.js`): a amostra não pode
     * acender a orb nem reabrir o mic sozinha (US-3 AC3).
     */
    async aoOuvirAmostra(vozId) {
      if (this.amostraTocandoId) return
      this.amostraErro = null
      this.amostraTocandoId = vozId
      try {
        const r = await apiVoz.amostra({ voice_id: vozId })
        if (r && r.status === 200 && r.value) {
          await tocarAmostra(r.value.audio_base64, r.value.content_type)
        } else {
          this.amostraErro = {
            vozId,
            mensagem: (r && r.message) || COMPOSER_CHAT.vozAmostraFalha,
          }
        }
      } finally {
        this.amostraTocandoId = ''
      }
    },
    abrirAnexos() {
      if (this.anexosDesabilitados) return
      const anexos = this.$refs.anexos
      if (anexos) anexos.abrirSeletor()
    },
    /**
     * Ponto de entrada ÚNICO das três portas (o "+", o Ctrl+K e o Ctrl+V).
     *
     * ⚠️ O teto é conferido AQUI, e não só no filho. Lá ele vive no gate do
     * `abrirSeletor`/`:disabled`, que o paste e o palette não atravessam — por
     * esses dois o array crescia sem limite.
     */
    onAdicionarArquivos(lista) {
      const entrando = Array.prototype.slice.call(lista || [])
      // [STRESS r1, G-8] ANTES do filtro — `arquivoAceito` descartava vazio/
      // acima-do-limite sem avisar nada; aqui o motivo chega à tela ANTES de o
      // arquivo desaparecer da lista.
      this.avisarArquivosRejeitadosPorTamanho(entrando)
      // [G-3, spec-010 QA] Idem para extensão fora da allowlist do composer
      // (`.exe` e afins) — antes recusada em SILÊNCIO por `arquivoAceito`.
      this.avisarArquivosSemExtensaoAceita(entrando)
      const cabem = MAX_ANEXOS - this.arquivos.length
      if (cabem <= 0) return
      const aceitos = entrando
        .filter((arquivo) => arquivo && this.arquivoAceito(arquivo))
        .slice(0, cabem)
      if (!aceitos.length) return
      this.arquivos = this.arquivos.concat(aceitos)
      // [spec-016 T023] Upload IMEDIATO — não espera o envio da mensagem. É
      // o mixin de upload que decide (cliente em foco ou `sem_cliente`).
      //
      // ★ [17/09/2026] Terminar o upload NÃO dispara turno nenhum: o anexo
      // fica pronto na fila e sai no próximo envio de quem escreve. O turno
      // automático de "anexo órfão" que existia aqui mandava mensagem sem
      // gesto da pessoa — mesmo defeito do turno de continuação removido em
      // `send-message-anexos-upload-mixin.js::tentarUploadPendentes`.
      aceitos.forEach((arquivo) => this.iniciarUploadDoArquivo(arquivo))
      // Anexar é meio, não fim: quem acabou de escolher o arquivo vai escrever
      // a pergunta. Vale para as quatro portas — pelo seletor e pelo palette o
      // foco está no diálogo que fechou, e pelo arrastar não está em lugar
      // nenhum.
      this.focarCampo()
    },
    /**
     * Tamanho e extensão — as duas regras que o `accept` do input não garante.
     *
     * ⚠️ O `accept` só filtra o SELETOR. Pelo arrastar e pelo colar o arquivo
     * chega sem passar por ele, e sem esta checagem as portas teriam critérios
     * diferentes para a mesma fila.
     */
    arquivoAceito(arquivo) {
      // [STRESS r1, G-8] Vazio tinha extensão válida e PASSAVA — ia para
      // `iniciarUploadDoArquivo` sem nada para enviar. `!arquivo.size` cobre
      // tanto `0` quanto `undefined`/`NaN` (arquivo sem `size` legível).
      if (!arquivo.size) return false
      if (arquivo.size > MAX_BYTES_POR_ANEXO) return false
      return EXTENSOES_PERMITIDAS.indexOf(getExtension(arquivo.name)) !== -1
    },
    /**
     * [STRESS r1, G-8] Medido: arquivo vazio (0 B) e arquivo acima do teto do
     * composer (`MAX_BYTES_POR_ANEXO`) eram descartados por `arquivoAceito`
     * sem NENHUM feedback — nem miniatura, nem aviso — e a pessoa não tinha
     * como saber por que o anexo "sumiu". `$showSnack` (padrão do repo para
     * feedback leve de ação — `CLAUDE.md` §Common Patterns) com o nome do
     * arquivo, o valor ofensor e o limite, sempre que uma das duas causas de
     * TAMANHO acontecer.
     *
     * ⚠️ Extensão fora da `EXTENSOES_PERMITIDAS` era descartada em SILÊNCIO —
     * gap conhecido, fora do escopo desta correção (a rodada só mediu as
     * duas causas de tamanho); fechado pelo `avisarArquivosSemExtensaoAceita`
     * abaixo (G-3, spec-010 QA).
     */
    avisarArquivosRejeitadosPorTamanho(arquivos) {
      arquivos.forEach((arquivo) => {
        if (!arquivo) return
        if (!arquivo.size) {
          this.$showSnack({
            text: COMPOSER_CHAT.anexoVazio(arquivo.name),
            color: 'error',
            button: true,
          })
          return
        }
        if (arquivo.size > MAX_BYTES_POR_ANEXO) {
          this.$showSnack({
            text: COMPOSER_CHAT.anexoExcedeLimite(
              arquivo.name,
              fileSize(arquivo.size),
              fileSize(MAX_BYTES_POR_ANEXO)
            ),
            color: 'error',
            button: true,
          })
        }
      })
    },
    /**
     * [G-3, spec-010 QA — `send-message.vue:793 arquivoAceito`] Extensão fora
     * das `EXTENSOES_PERMITIDAS` do composer (`.exe` e afins) era descartada
     * ANTES mesmo de chegar em `iniciarUploadDoArquivo` — o guard de canal
     * desconhecido daquele método (`mensagemCanalDesconhecido`) nunca era
     * alcançado, porque o arquivo nem entrava em `this.arquivos`. Sem nenhum
     * aviso, o "sumiço" era indistinguível de um bug de UI.
     *
     * Mesma frase de `mensagemCanalDesconhecido` (nomeia o arquivo e as DUAS
     * listas de canal aceitas) — um só vocabulário para "este arquivo não
     * tem para onde ir", venha a recusa daqui (allowlist do composer) ou de
     * dentro do mixin de upload (`.gif`/`.pptx`, que passam esta allowlist
     * mas não têm canal de rede).
     *
     * ⚠️ Vazio e acima-do-limite (tratados acima) não entram aqui de novo —
     * `!arquivo.size` cobre os dois antes da checagem de extensão.
     */
    avisarArquivosSemExtensaoAceita(arquivos) {
      arquivos.forEach((arquivo) => {
        if (!arquivo || !arquivo.size) return
        if (arquivo.size > MAX_BYTES_POR_ANEXO) return
        const extensaoAceita =
          EXTENSOES_PERMITIDAS.indexOf(getExtension(arquivo.name)) !== -1
        if (extensaoAceita) return
        this.$showSnack({
          text: mensagemCanalDesconhecido(arquivo),
          color: 'error',
          button: true,
        })
      })
    },
    aoArrastarSobre() {
      if (this.anexosDesabilitados) return
      this.arrastando = true
    },
    aoSairDoArraste() {
      this.arrastando = false
    },
    /**
     * Soltar arquivo em cima da caixa.
     *
     * ⚠️ O `@dragover` precisa de `.prevent` mesmo sem fazer nada visual: sem
     * ele o browser recusa o drop e ABRE o arquivo numa aba, tirando a pessoa
     * do chat.
     */
    aoSoltar(evento) {
      this.arrastando = false
      if (this.anexosDesabilitados) return
      const dados = evento && evento.dataTransfer
      const lista = dados && dados.files
      if (lista && lista.length) this.onAdicionarArquivos(lista)
    },
    /**
     * Ctrl+V com imagem na área de transferência.
     *
     * ⚠️ `preventDefault()` SÓ quando achou imagem. O evento carrega texto E
     * imagem em alguns browsers, e prevenir sempre cola o `data:image/...` como
     * texto dentro do campo — o defeito está registrado em
     * `atendimento/chat-input.vue`. Colar texto continua sendo do textarea.
     */
    aoColar(evento) {
      if (this.anexosDesabilitados) return
      const imagens = imagensDoClipboard(evento)
      if (!imagens.length) return
      evento.preventDefault()
      this.onAdicionarArquivos(imagens)
    },
    onRemoverArquivo(indice) {
      // [spec-016 T023] Limpar o status ANTES do splice — depois o índice já
      // não aponta para o mesmo arquivo.
      const arquivo = this.arquivos[indice]
      if (arquivo) this.limparStatusUpload(arquivo)
      this.arquivos.splice(indice, 1)
    },
    /**
     * Escolher num menu devolve o cursor ao campo — quem abriu o menu estava
     * escrevendo e vai continuar escrevendo.
     *
     * ⚠️ Em `$nextTick`: o `close()` do `composer-inline-select` devolve o foco
     * ao GATILHO antes de disparar o `onClick` da opção, e o `v-menu` do escopo
     * ainda está desmontando o painel. Sem esperar, o foco daqui era desfeito
     * logo em seguida e era preciso clicar no campo de novo.
     */
    focarCampo() {
      this.$nextTick(() => {
        const textarea = this.elementoDoCampo()
        if (textarea) textarea.focus()
      })
    },
    /**
     * A `/` e o que veio depois dela são o COMANDO, não a mensagem: executado o
     * comando, o campo volta vazio. Sem isto o `/agente` ficaria na caixa e
     * seguiria como pergunta no Enter seguinte.
     */
    limparComando() {
      this.$emit('input', '')
    },
    comandoNovaConversa() {
      this.limparComando()
      this.$emit('nova-conversa')
      this.focarCampo()
    },
    // Os três que abrem OUTRO menu não devolvem o foco ao campo: quem acabou de
    // pedir `/agente` quer navegar no menu de agente, e o `abrir(true)` já leva
    // o foco para a primeira opção de lá.
    comandoAgente() {
      this.limparComando()
      this.abrirAgente()
    },
    /**
     * Abre o modal de anexo da carteira.
     *
     * Vai pelo `GlobalBus`, e não por `$emit`: o modal já se registra nele
     * (`modal-carteira-chat-anexo` faz `GlobalBus.$on` no `created`), e subir
     * um evento daqui até a superfície exigiria repasse em cada nível
     * intermediário — a mesma lacuna de neto-para-avô que o `open-service`
     * documenta em `messages.vue`.
     */
    comandoAnexarCarteira() {
      this.limparComando()
      GlobalBus.$emit(MODAL.FEE_FIXO_CARTEIRA_CHAT_ANEXO)
    },
    /**
     * `/anexar` — limpa a barra e devolve o foco ANTES de abrir o seletor.
     *
     * ⚠️ A ordem importa. O seletor de arquivo é um diálogo do SISTEMA e leva o
     * foco embora; ao fechar, o browser o devolve a quem o tinha. Focando o
     * campo primeiro, o cursor volta para lá — chamar `focarCampo()` depois
     * disputaria com o diálogo que acabou de abrir.
     */
    comandoAnexar() {
      this.limparComando()
      this.focarCampo()
      this.abrirAnexos()
    },
    comandoCliente() {
      this.limparComando()
      this.abrirEscopo()
    },
    /**
     * Um ponto de decisão só para os dois caminhos que abrem estas listas — o
     * clique no chip e o comando da `/`.
     *
     * Na `/ia` (`estiloLimpo`) elas vivem no palette centralizado: os chips
     * ficam no rodapé, e o painel deles subindo já custou correção de direção,
     * de largura e de respiro. Nas outras superfícies o dropdown segue.
     */
    abrirAgente() {
      if (this.usarPaletteNosChips) {
        GlobalBus.$emit(MODAL.IA_PALETTE, { escopo: ESCOPO_AGENTES })
        return
      }
      const agente = this.$refs.agente
      if (agente) agente.abrir()
    },
    abrirEscopo() {
      if (this.usarPaletteNosChips) {
        GlobalBus.$emit(MODAL.IA_PALETTE, { escopo: ESCOPO_CLIENTES })
        return
      }
      const escopo = this.$refs.escopo
      if (escopo) escopo.abrir()
    },
    /**
     * `/modelo` — mesma bifurcação do agente e do cliente.
     *
     * ⚠️ Na `/ia` o CHIP do modelo não existe (a fileira cabe numa linha só),
     * então `$refs.modelo` é `undefined` e o comando abria coisa nenhuma. O chip
     * sumir é decisão de LAYOUT; trocar de modelo continua sendo possível, e o
     * palette é onde isso vive agora.
     */
    comandoModelo() {
      this.limparComando()
      if (this.usarPaletteNosChips) {
        GlobalBus.$emit(MODAL.IA_PALETTE, { escopo: ESCOPO_MODELOS })
        return
      }
      const modelo = this.$refs.modelo
      if (modelo) modelo.abrir(true)
    },
    comandoRaciocinio() {
      this.limparComando()
      this.onToggleThinking()
      this.focarCampo()
    },
    // `IA_PALETTE` e não `GLOBAL_SEARCH`: dentro da `/ia` quem responde é o
    // palette da IA (conversas, agentes, modelos). Fora dela ele mesmo devolve
    // para a busca global — a decisão de rota mora lá, num lugar só.
    comandoBuscar() {
      this.limparComando()
      GlobalBus.$emit(MODAL.IA_PALETTE)
    },
    aoEscolherFerramenta(ferramenta) {
      this.limparAtalhoSelecionado()
      this.$emit('escolher-ferramenta', ferramenta)
      this.focarCampo()
    },
    aoTrocarEscopo(cliente) {
      this.$emit('escopo-change', cliente)
      this.focarCampo()
    },
    onTrocarAgente(agenteId) {
      this.$emit('change-agent', agenteId)
      this.focarCampo()
    },
    onToggleThinking() {
      if (this.loading) return
      this.$store.dispatch(
        this.storeModule + '/setThinkingEnabled',
        !this.thinkingEnabled
      )
    },
    /**
     * Voz (v1, por turnos) — todos os wrappers abaixo delegam pro motor
     * (`utils/motor-de-voz.js`), que é quem de fato pede o microfone, grava,
     * transcreve e guarda o estado. Ver o comentário nas seis computeds
     * (`gravando`, `modoDeVoz`, ...) pro porquê da divisão.
     */
    // Os dois gatilhos diretos do template (ChatGPT: sem menu) — mic sempre
    // visível dispara Ditar; a bolha do botão de enviar, com o campo vazio,
    // dispara o Modo de Voz.
    iniciarDitar() {
      this.iniciarGravacao(MODO_DITAR)
    },
    iniciarVoz() {
      if (this.envioBloqueado) return
      this.iniciarGravacao(MODO_VOZ)
    },
    // Método (não computed): `$slots` não é reativo no Vue 2 — o computed
    // congelaria no primeiro render. Conta só vnode com tag ou texto real;
    // o comentário que um `v-if` falso deixa não conta.
    temCabecalho() {
      const vnodes = this.$slots.cabecalho || []
      return vnodes.some(function (vnode) {
        return Boolean(vnode.tag) || Boolean(vnode.text && vnode.text.trim())
      })
    },
    /** O clique único do botão de enviar, nos três estados que ele assume. */
    aoClicarEnviar() {
      if (this.mostraIniciarVoz) {
        this.iniciarVoz()
        return
      }
      if (this.loading) {
        this.onAbort()
        return
      }
      this.onSend()
    },
    /**
     * spec-008 [T030c] — o terceiro argumento de `iniciar` é o
     * `ContextoDeSessao` (`contracts/transporte.md`), e este componente é o
     * PRODUTOR dele: a `superficie` e o `delegar` vêm da tela, por prop.
     *
     * ★ [T046] **Nenhuma bandeira é lida aqui** (D-O-4): o tempo real é o
     * PADRÃO do Modo de Voz. O que este método produz são fatos do turno — que
     * tela está pedindo e se é a reabertura de uma queda —, e quem decide o
     * transporte a partir deles é o ponto único de seleção.
     *
     * ⚠️ `abrir` RECUSA sessão sem `superficie` (`MOTIVO_SEM_SUPERFICIE`): o
     * composer montado sem a prop (popup, painel do Hub, Fee-Based,
     * ai-framework) segue no caminho por turnos de sempre — ver
     * `utils/contexto-de-voz-tempo-real.js`.
     */
    contextoDeVoz({ forcarPorTurnos = false } = {}) {
      return montarContextoDeVozTempoReal({
        superficie: this.superficieDeVoz,
        idConversa: this.idConversaDeVoz,
        delegar: this.delegarVoz,
        forcarPorTurnos,
        nomeDoConsultor: this.nomeDoConsultor(),
        // ★ [T065] O valor já em mãos (D-O-5) — o getter da superfície, não
        // um valor: ele é consultado a cada acompanhamento da espera.
        lerValorParcialDoTurno: this.lerValorParcialDeVoz,
      })
    },
    /**
     * ★ [spec-008 T062] Quem está do outro lado, **lido da SESSÃO**.
     *
     * É o invariante N21 aplicado ao cumprimento: o nome que a voz diz vem do
     * usuário logado, e nunca do modelo — que altera identificador em 7 de 8
     * medições (`Teste Alfa` → `"Teste Alpha"`, G-12 §6 + G-13 §3).
     *
     * ⚠️ Método, não computed: `$currentUser()` lê o store de autenticação a
     * cada chamada e é consultado UMA vez por sessão de voz, na abertura —
     * um computed guardaria o nome de quem estava logado quando o composer
     * montou, e este componente sobrevive a troca de tela.
     *
     * Defensivo como o resto do módulo (`mixins/aviso-de-creditos.js`): o
     * mesmo composer é montado pelo popup, pelo painel do Hub, pelo Fee-Based
     * e pelo ai-framework. Sem nome, devolve `''` — e a saudação sai sem
     * nome, nunca com placeholder.
     */
    nomeDoConsultor() {
      const usuario = (this.$currentUser && this.$currentUser()) || {}
      return String(usuario.nome || '')
    },
    iniciarGravacao(modo, { forcarPorTurnos = false } = {}) {
      return iniciarMotorDeVoz(
        modo,
        {
          avisarSemSuporte: () => {
            this.$showSnack({
              text: COPY_VOZ.semSuporteAudio,
              color: 'error',
              button: true,
            })
          },
          avisarErro: (mensagem) => {
            this.$showSnack({ text: mensagem, color: 'error', button: true })
          },
        },
        this.contextoDeVoz({ forcarPorTurnos })
      )
    },
    /**
     * spec-008 [T030c] — o `MediaStream` do `audioRemoto` ligado ao `<audio>`.
     *
     * ★ **Quem anexa é a TELA**: o transporte fica SEM DOM por desenho
     * (`transporte-tempo-real.js`, "Um evento a MAIS no `Destino`"), e sem
     * esta linha a sessão é paga e MUDA — era o estado do repositório até
     * aqui. `interromper` silencia a trilha pelo `track.enabled` do lado de
     * lá; este elemento não precisa saber disso.
     *
     * `muted` NUNCA é mexido aqui: o mudo do consultor é do MICROFONE
     * (`alternarMudo`, trilha local), e silenciar o alto-falante no mesmo
     * gesto faria a IA falar sozinha no vazio de uma sessão paga.
     */
    anexarAudioDaVoz(fluxo) {
      const elemento = this.$refs.audioDaVoz
      if (!elemento || !fluxo) return
      if (elemento.srcObject === fluxo) return
      elemento.srcObject = fluxo
      this.tocarAudioDaVoz(elemento)
    },
    /**
     * ⚠️ `play()` falha de DUAS formas, e as duas precisam de tratamento —
     * medido, não suposto: a Promise REJEITADA (autoplay barrado, o caso do
     * navegador) e o THROW SÍNCRONO (`HTMLMediaElement.prototype.play` é
     * `Not implemented` no jsdom, e navegador antigo também lança). Só o
     * `.catch` deixava o throw escapar de dentro do `mounted()` — e aí não é o
     * áudio que falha, é a MONTAGEM inteira do composer.
     *
     * Engolir é deliberado nos dois casos: a sessão foi aberta por um clique
     * do consultor (o gesto que libera o autoplay), o áudio segue chegando
     * pela trilha, e um `console.error` REPROVA o teste por desenho
     * (`tests/unit/setup.js`) sem dizer nada útil a ninguém.
     */
    tocarAudioDaVoz(elemento) {
      if (!elemento || typeof elemento.play !== 'function') return
      try {
        const tocando = elemento.play()
        if (tocando && typeof tocando.catch === 'function') tocando.catch(() => {})
      } catch (erro) {
        // sem canal: o elemento já tem `srcObject`, e o navegador retoma
        // sozinho no próximo gesto.
      }
    },
    /**
     * spec-008 [T034], estendido pela [T030c] ao MEIO da sessão: o canal caiu
     * (evento `queda`), então encerra o tempo real e segue pelo Modo de Voz de
     * sempre — na mesma sessão do consultor, sem ele recomeçar nada.
     *
     * ★ Isto é o que torna a copy do [T034] verdadeira. Ela promete "seguimos
     * pelo modo de voz de sempre"; dizê-la e parar aqui deixaria o consultor
     * olhando para um composer mudo com a promessa na tela.
     *
     * `forcarPorTurnos` existe para a reabertura NÃO reescolher o tempo real:
     * o canal que acabou de cair seria tentado de novo, em laço.
     */
    async cairParaVozPorTurnos() {
      await this.sairDoModoDeVoz()
      return this.iniciarGravacao(MODO_VOZ, { forcarPorTurnos: true })
    },
    /**
     * Para a gravação, transcreve no servidor e decide o destino do texto
     * pelo MODO que estava ativo — ver `_destinoDoMotor` (`mounted()`):
     * Ditar preenche `value` (via `@input`) e devolve o foco ao campo, SEM
     * enviar; Modo de voz emite `enviar-voz`, ADITIVO ao `send` existente (o
     * pai decide o que fazer — ver `view-chat.vue`).
     */
    pararGravacao() {
      return pararMotorDeVoz()
    },
    /**
     * [feedback do usuário, 04/09] Esc CANCELA a gravação em andamento — nem
     * transcreve, nem preenche, nem envia. Diferente de `pararGravacao`
     * (Enter/clique no botão), que processa o que foi dito.
     */
    cancelarGravacaoPorEsc() {
      return cancelarMotorDeVoz()
    },
    /**
     * [feedback do usuário, 04/09 — 5ª rodada] Mudo do Modo de Voz —
     * silencia o microfone SEM parar a gravação.
     */
    alternarMudo() {
      alternarMudoMotorDeVoz()
    },
    /**
     * [feedback do usuário, 04/09] "eu nunca consigo... sair da conversa
     * contínua" — sai do Modo de Voz de qualquer estado (IA falando, mic
     * escutando, ou o respiro entre os dois), sem transcrever nem enviar
     * nada. Diferente de `pararGravacao` (que PROCESSA o que foi dito).
     */
    sairDoModoDeVoz() {
      return sairDoModoDeVozMotor()
    },
    /** Handler do `document` ligado só enquanto `gravando` — ver o `watch`. */
    onDocumentKeydownEsc(event) {
      if (event.key !== 'Escape') return
      event.preventDefault()
      this.cancelarGravacaoPorEsc()
    },
  },
}
</script>

<template>
  <div class="send-message-wrapper pt-3 pb-1" :class="classesWrapper">
    <!-- ★ [spec-008 T030c] A saída de áudio da sessão em TEMPO REAL. É O
         ELEMENTO que faltava: `audioRemoto` entrega um `MediaStream` (não
         data channel) e o transporte fica SEM DOM de propósito — com a
         bandeira ligada e sem este `<audio>`, a sessão era PAGA e MUDA.

         ⚠️ Montado SEMPRE, nunca sob `v-if`: `ontrack` dispara UMA vez, logo
         na negociação, e um elemento que só existisse "durante a sessão"
         poderia não estar no DOM no instante do evento. Sem `src` ele não
         desenha nem baixa nada — é inerte nas superfícies que não pediram
         voz em tempo real.

         `controls` de propósito AUSENTE: quem comanda a fala são os botões do
         composer (mudo, sair, interromper); uma segunda barra de controles
         nativa disputaria com eles e sairia do design system. -->
    <audio
      ref="audioDaVoz"
      class="send-message-audio-da-voz"
      aria-hidden="true"
      autoplay
    />
    <!-- Glow do Modo de Voz: neutro enquanto o usuário fala, `--primary`
         enquanto a IA fala. Só monta quando alguém está de fato falando —
         não há estado ocioso/processando aqui (ver estadoDaFala).
         [feedback do usuário, 04/09] E NÃO no herói (`large`, estado vazio
         sem conversa) — só no rodapé, com a conversa em andamento. -->
    <!-- [bug corrigido, 04/09] SEM a classe `send-message-voz-orb` — o Vue
         funde `class` do pai com a raiz do filho, e essa classe carregava
         regras de posicionamento que colidiam com as do próprio componente
         (ver o comentário em `composer-voz-orb.vue`). O componente é dono
         completo do próprio posicionamento agora. -->
    <!-- `nivel` só é real enquanto o USUÁRIO fala (RMS do mic, ao vivo); com
         a IA falando não há medidor sobre o áudio de playback — o espectro
         fica no piso decorativo nesse estado, v1 conhecido.
         [spec-017 T004] `estadoVisualDoOrb` (não `estadoDaFala` cru) — ver o
         computed: cobre também o estado "sessão ativa, mic fechado", sem o
         qual a orb somia nessa janela.
         ★ [spec-008 T060] Com `sessaoDeVozAtiva` o computed não devolve mais
         `null`: o `v-if` deixa de ser a porta por onde a orb sumia no meio da
         sessão e passa a marcar só as duas ausências LEGÍTIMAS — fora de
         sessão, e no composer herói (`large`), onde não há conversa atrás.
         ★ [spec-008 T061] EM FLUXO, primeiro filho do wrapper: ela empurra a
         caixa para baixo em vez de pousar por cima da conversa (o print do
         owner, com a bolinha sobre a linha da tabela). Toda a geometria mora
         em `composer-voz-orb.vue` — aqui não há uma linha de posicionamento,
         e é de propósito (ver o bug da classe do pai colidindo com a raiz do
         filho, logo acima). -->
    <ComposerVozOrb
      v-if="estadoVisualDoOrb && !large"
      :mode="estadoVisualDoOrb"
      :nivel="nivelDoMicrofone"
    />
    <!-- ⚠️ `@paste` na CAIXA, e não no campo: é o que o composer de comentário
         de tarefa faz, e por um motivo — o `markdown-field` do repo tem um
         `onPaste` próprio que previne o default quando há texto. Aqui só a
         imagem é interceptada; texto continua caindo no textarea. -->
    <!-- Cabeçalho da caixa: uma ABA atrás do composer (print de referência do
         usuário, 14/09/2026). Gateado pelo SLOT, não por prop: sem o gate, as
         outras superfícies que montam este composer (popup, painel do Hub,
         Fee-Based, ai-framework) ganhariam a faixa sem pedir. Quem preenche é
         quem sabe do assunto — o componente continua sem ler store.
         ★ IRMÃ ANTES da caixa, nunca dentro dela: no modo `--limpo` a caixa é
         um flex de UMA fileira (`nowrap`, toolbar em `display: contents`, tudo
         ordenado por `order`), e um elemento solto no slot caía em `order: 0`
         — na frente do "+", espremido na fileira do campo; no `--multilinha`
         virava irmão do textarea e esticava a caixa. Aqui fora ela é um bloco
         mais estreito que a caixa, com raio só em cima, cuja base some atrás
         da caixa branca (ver `.send-message-cabecalho` no style). -->
    <!-- `$slots.cabecalho` é truthy mesmo quando o filho fica em `v-if` falso
         (sobra um comentário): a aba vazia desenhava borda + fundo como uma
         linha "dupla" acima da caixa (achado ao vivo, 14/09/2026). Só monta
         com conteúdo REAL; o `:empty` do style é o cinto para o comentário. -->
    <!-- [15/09/2026] A aba entra e sai suave (`send-message-aba`): o "×" da
         faixa de saldo baixo a fecha em fade + recolhimento, sem a caixa pular. -->
    <transition name="send-message-aba">
      <div v-if="temCabecalho()" class="send-message-cabecalho">
        <slot name="cabecalho" />
      </div>
    </transition>
    <div
      ref="caixa"
      class="send-message-inner"
      :class="classesCaixa"
      :style="estiloDaCaixa"
      @paste="aoColar"
      @dragover.prevent="aoArrastarSobre"
      @dragleave="aoSairDoArraste"
      @drop.prevent="aoSoltar"
    >
      <!-- Gap G3: a fila de chips existe e é testada; nasce sempre vazia
           porque o "+" que a alimenta está desabilitado. -->
      <!-- ⚠️ SEM classe de padding aqui. O `px-2 pt-1` que morava neste ponto
           existia mesmo com a fila VAZIA e empurrava o "+" para dentro da
           caixa — foi o que obrigou a esconder a prévia no modo limpo. O
           respiro passou para `.composer-attachments__lista`, que só existe
           quando há item. -->
      <ComposerAttachments
        v-if="showAttachments"
        ref="anexos"
        :arquivos="arquivos"
        :disabled="anexosDesabilitados"
        :status-por-chave="statusUploadParaExibir"
        :mensagem-erro-por-chave="mensagemErroPorChave"
        @add="onAdicionarArquivos"
        @remove="onRemoverArquivo"
      />

      <!-- O aviso diz o que NÃO vai junto neste turno — e o turno parte assim
           mesmo. Sem ele o anexo sumiria em silêncio e a pessoa acharia que a
           IA o viu; com ele, ela decide se manda agora ou resolve o anexo antes.
           [S-4, design-conformance 05/09/2026] `<output>` (que já traz o `role`
           de `status`) + `aria-live` em `polite` — sem isso o aviso nunca
           chegava a quem navega por leitor de tela.

           ★ O ícone/cor de AVISO (`warning`, `var(--warning-text)`) FICA, e a
           decisão é da própria spec-009 — está registrada no teste S-4
           (`send-message.unit.js`): o aviso deixou de bloquear, mas continua
           dizendo que o item **não vai junto no próximo envio**, e isso é
           adverso à expectativa de quem acabou de anexar. Diferente do
           `<output>` logo abaixo, que CONFIRMA um destino (nada deu errado) e
           por isso é neutro. Uma revisão de design-conformance sugeriu trocar
           por `info-circle` em 20/09 sem ter lido esta decisão; o teste S-4
           barrou a troca, que é o trabalho dele. -->
      <output
        v-if="avisoDeAnexo"
        class="send-message-aviso-anexo ia-texto-auxiliar"
        aria-live="polite"
      >
        <icon-svg name="warning" :size="12" color="var(--warning-text)" />
        {{ avisoDeAnexo }}
      </output>

      <!-- ★ teste-11: o DESTINO do anexo, dito antes do envio. Cor neutra
           (não `warning`): não há nada errado aqui — é a confirmação de que
           a carteira vai para o cliente certo, e o alarme falso a cada anexo
           gastaria a atenção que o aviso de verdade acima precisa. -->
      <output
        v-if="destinoDoAnexo"
        class="send-message-aviso-anexo ia-texto-auxiliar"
        data-teste="destino-do-anexo"
        aria-live="polite"
      >
        <icon-svg name="user-2" :size="12" color="var(--neutral-700)" />
        {{ destinoDoAnexo }}
      </output>

      <!-- ★ [spec-008 T030c] As TRÊS linhas da sessão em tempo real. Mesma
           régua das duas acima (`role="status"` + `aria-live="polite"`, ícone
           de 12px, texto de apoio): são avisos do composer, não peças novas —
           repetir o padrão é o que mantém o ritmo da caixa.

           A ORDEM é a da hierarquia: o que o consultor está dizendo AGORA, a
           decisão que espera decisão dele, e o aviso de que a sessão vai
           encerrar. Só a do meio ganha `--primary`: uma ênfase por vez. -->
      <span
        v-if="mostrarTranscricaoDeVoz"
        class="send-message-aviso-anexo"
        data-teste="transcricao-de-voz"
        role="status"
        aria-live="polite"
      >
        <icon-svg name="microphone" :size="12" color="var(--neutral-700)" />
        {{ rotulosDeVozTempoReal.vocEstaFalando }}: {{ transcricaoDeVoz }}
      </span>

      <!-- ⚠️ D-13/N16: esta linha REMETE ao cartão e não carrega valor,
           cliente, ativo nem data-base. O canal falado altera identificador em
           6 de 11 medições (G-11) — o dado de negócio vive no cartão da
           conversa, que é quem o recebeu do servidor. -->
      <span
        v-if="propostaDeVozAguardando"
        class="send-message-aviso-anexo"
        data-teste="proposta-de-voz"
        role="status"
        aria-live="polite"
      >
        <icon-svg name="info-circle" :size="12" color="var(--primary)" />
        {{ rotulosDeVozTempoReal.propostaAguardando }}
      </span>

      <!-- [T035] O aviso vem 60 s antes do corte porque o tique do ledger do
           provedor é de 15 s — limiar menor poria aviso e corte no mesmo
           instante. Sem esta linha, a sessão PAGA some sem explicação. -->
      <span
        v-if="avisoDeVozTempoReal"
        class="send-message-aviso-anexo"
        data-teste="aviso-de-voz-tempo-real"
        role="status"
        aria-live="polite"
      >
        <icon-svg name="timer-warning" :size="12" color="var(--warning-text)" />
        {{ avisoDeVozTempoReal }}
      </span>

      <!-- Textarea não fica desabilitado durante o loading — desabilitar um
           campo focado faz o browser tirar o foco automaticamente
           (comportamento nativo), obrigando o usuário a clicar de novo pra
           continuar digitando. onSend()/canSend() já bloqueiam envio
           duplicado independente disso. -->
      <!-- Sem × no chip: quem remove é o `Backspace` com o campo vazio, que é
           o gesto do ChatGPT. Um botão a mais aqui competia com o "+" logo ao
           lado dentro de uma caixa de 52px.

           ⚠️ O chip é IRMÃO do campo, não conteúdo dele. O campo é um
           `<textarea>`, que só aceita texto — não há como pôr um elemento
           dentro. Visualmente fica como no ChatGPT; tecnicamente é honesto
           sobre o que é. -->
      <ComandoChip
        v-if="chipDoComposer"
        ref="chipDaFerramenta"
        class="send-message-ferramenta-chip"
        :style="estiloDoChip"
        :rotulo="chipDoComposer.rotulo"
        :selecionado="chipNaSelecao"
        @mousedown.native.prevent="selecionarTudoComChip"
      />

      <!-- [feedback do usuário, 04/09 — pivô ChatGPT] "no modo ditado, a
           parte de espectro eh continue da esquerda para a direita" — o
           espectro OCUPA o lugar do campo (não fica por cima dele) enquanto
           o Ditar grava; o Modo de Voz não toca aqui (usa a orb acima).

           ⚠️ [bug corrigido, 04/09] a classe `send-message-textarea` é
           OBRIGATÓRIA aqui — é o que dá a este componente o MESMO `order`/
           `flex` que o textarea tem nos modos `--limpo`/`--multilinha`. Sem
           ela, o elemento caía no `order: 0` (padrão do flex) e pulava pra
           FRENTE do "+" (que é `order: 1`), deslocando toda a fileira de
           botões — exatamente o defeito já registrado para
           `.send-message-ferramenta-chip` e as classes da gravação (ver os
           comentários de `order` mais abaixo). O `<ComposerDitarEspectro>`
           não define nada conflitante nessa classe (só usa a própria
           `.composer-ditar-espectro` para o layout interno das barras). -->
      <ComposerDitarEspectro
        v-if="gravando && !modoDeVoz"
        class="send-message-textarea"
        :nivel="nivelDoMicrofone"
      />
      <input-by-type
        v-else
        ref="campo"
        type="textarea"
        :value="value"
        :placeholder="placeholderEfetivo"
        rows="1"
        auto-grow
        hide-details
        dense
        solo
        flat
        class="send-message-textarea"
        @input="onInput"
        @keydown.delete.native="aoApagar"
        @copy.native="aoCopiarComChip"
        @cut.native="aoRecortarComChip"
        @paste.native="aoColarComando"
      />
      <!-- ⚠️ As classes utilitárias do Vuetify saem no modo limpo. A `d-flex` é
           `display: flex !important`, e ela vencia o `display: contents` que
           dissolve esta barra — a barra seguia sendo UM item de flex, os
           filhos não viravam irmãos do campo, e o `order` deles não tinha
           efeito nenhum. O sintoma era os botões à esquerda e o texto
           espremido no meio. Tirar a classe é mais honesto que somar um
           segundo `!important`. -->
      <div
        class="send-message-toolbar"
        :class="{ 'd-flex align-center az-gap-small': !estiloLimpo }"
      >
        <!-- Tooltip no <span> e não no <button>: elemento desabilitado não
             dispara mouseenter, então o tooltip nunca apareceria. -->
        <!-- ⚠️ SEM `v-tooltip` no modo limpo, e não é preferência: o
             `v-tooltip` posiciona o balão a partir do RETÂNGULO do ativador, e
             ali o ativador tem `display: contents` para o botão virar item de
             flex. Elemento `contents` não tem caixa — o rect volta vazio e o
             Vuetify ancora em 0,0, ou seja, no canto superior da PÁGINA. O
             `title` nativo pende do próprio botão e não mede nada. -->
        <!-- Com ferramentas, o "+" abre o MENU delas e o anexo entra como a
             primeira linha lá dentro. Sem elas (popup, painel do Hub), ele
             continua sendo o botão de anexo que sempre foi. -->
        <ComposerFerramentas
          v-if="temFerramentas"
          ref="ferramentas"
          class="send-message-ferramentas"
          :modulos="ferramentas"
          :comandos="comandosDoComposer"
          :modo-comando="emModoComando"
          :filtro="filtroDeFerramentas"
          :module-key-ativo="ferramentaAtiva ? ferramentaAtiva.moduleKey : ''"
          :mostra-anexo="showAttachments"
          :rotulo-do-anexo="rotuloAnexos"
          :anexo-indisponivel="anexosDesabilitados"
          :disabled="gravando"
          @escolher="aoEscolherFerramenta"
          @anexar="abrirAnexos"
          @sair-pelo-topo="focarCampo"
          @abriu-sem-foco="focarCampo"
        />

        <button
          v-else-if="showAttachments && estiloLimpo"
          type="button"
          class="send-message-anexo"
          :disabled="anexosDesabilitados || gravando"
          :aria-label="rotuloAnexos"
          :title="rotuloAnexos"
          @click="abrirAnexos"
        >
          <icon-svg name="plus-line" :size="16" color="var(--neutral-700)" />
        </button>

        <!-- Tooltip no <span> e não no <button>: elemento desabilitado não
             dispara mouseenter, então o tooltip nunca apareceria. -->
        <v-tooltip v-else-if="showAttachments" top>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              <button
                type="button"
                class="send-message-anexo"
                :disabled="anexosDesabilitados || gravando"
                :aria-label="rotuloAnexos"
                @click="abrirAnexos"
              >
                <!-- `plus-line`, o "+" do protótipo. O `plus` do set é na
                     verdade `plus-square` (tem moldura), daí o ícone novo. -->
                <icon-svg
                  name="plus-line"
                  :size="16"
                  color="var(--neutral-700)"
                />
              </button>
            </span>
          </template>
          <span>{{ rotuloAnexos }}</span>
        </v-tooltip>

        <!-- Os tres chips lem como um TRIO: cada um diz uma escolha que vale
             para a proxima mensagem (quem responde, com qual modelo, sobre
             quem). Container proprio porque a distancia entre eles e menor que
             a da toolbar, que separa grupos diferentes. Ordem: os dois que
             definem o RESPONDENTE primeiro, e o escopo por ultimo. -->
        <div class="send-message-chips d-flex align-center">
          <AgentSelect
            v-if="showAgentSelect"
            ref="agente"
            :so-icone="estiloLimpo"
            :motivo-da-trava="rotuloTravaConversa"
            :agentes="agentes"
            :agente-ativo-id="agenteAtivoId"
            :disabled="agentSelectDisabled"
            :abrir-por-fora="usarPaletteNosChips"
            @change="onTrocarAgente"
            @abrir-externo="abrirAgente"
          />

          <!-- `align` em `left` porque daqui o painel precisa crescer para a
               direita — com `right` sairia da caixa.
               spec-003 §5 / G5: `hideModelSelect` derruba o trio modelo + hint
               de modelo (`mostraModeloFixo`) + thinking; o parceiro nunca ve
               modelo.
               --primary e nao --aawz-green-color: o verde fixo dava 2.69 sobre
               o branco do menu e REPROVAVA o minimo de 3:1 da WCAG 1.4.11.
               O icone tambem vai de --primary (era --neutral-700): os tres
               chips carregam a cor no icone, e so o do modelo destoava. -->
          <ComposerInlineSelect
            v-if="!modeloOculto"
            ref="modelo"
            active-color="var(--primary)"
            icon="ia-head"
            icon-color="var(--primary)"
            :label="modelTriggerLabel"
            :options="modelSelectOptions"
            :disabled="modelSelectDisabled"
            align="left"
            class="send-message-model-select"
          />

          <!-- Escopo por ULTIMO: os dois anteriores definem quem responde, este
               define sobre quem — e e o unico que muda de rotulo conforme a
               escolha, entao no meio ele empurrava os vizinhos de lugar a cada
               troca de cliente. -->
          <EscopoSelect
            v-if="escopoDeCliente"
            ref="escopo"
            :so-icone="estiloLimpo"
            :clientes="clientes"
            :cliente="clienteEscopo"
            :agente="agenteAtivo"
            :disabled="escopoTravado"
            :abrir-por-fora="usarPaletteNosChips"
            @change="aoTrocarEscopo"
            @abrir-externo="abrirEscopo"
          />

          <!-- spec-016 [T005] — só durante a sessão de Modo de Voz
               (`sessaoDeVozAtiva`, motor-de-voz.js): visível do clique na
               bolha até X/Esc de verdade, sem piscar entre falas/escuta. -->
          <VozSelect
            v-if="mostrarSeletorDeVoz && sessaoDeVozAtiva"
            :so-icone="estiloLimpo"
            :vozes="catalogoDeVozes"
            :voz-ativa-id="vozSelecionada"
            :amostra-tocando-id="amostraTocandoId"
            :amostra-erro="amostraErro"
            @change="aoTrocarVoz"
            @ouvir="aoOuvirAmostra"
          />
        </div>

        <!-- Hint único dos dois locks: o texto diz qual deles caiu (só agente,
             só modelo, ou os dois) e vem depois dos seletores que ele explica. -->
        <span
          v-if="rotuloTravaConversa && !estiloLimpo"
          class="send-message-locked-hint ia-texto-micro d-flex align-center az-gap-xxsmall"
        >
          <icon-svg name="lock" :size="12" color="var(--neutral-700)" />
          {{ rotuloTravaConversa }}
        </span>

        <div class="flex-grow-1"></div>

        <button
          v-if="mostraThinkingToggle"
          type="button"
          :disabled="loading"
          :class="[
            'ia-thinking-chip az-ds-label d-inline-flex align-center az-gap-xsmall px-2 pt-1 pb-1 flex-shrink-0',
            thinkingEnabled
              ? 'ia-thinking-chip--active'
              : 'ia-thinking-chip--off',
          ]"
          @click="onToggleThinking"
        >
          <icon-svg name="mdi-brain" :size="12" />
          <span>{{ rotuloDoRaciocinio }}</span>
        </button>

        <!-- [feedback do usuário, 04/09 — pivô ChatGPT] Mic PLANO, SEMPRE
             visível (independente de ter texto — "no hover tem animacao"),
             ao lado do botão de enviar/iniciar-voz. Sem menu: clique dispara
             Ditar direto. Some só enquanto grava ou envia. -->
        <button
          v-if="!gravando && !loading"
          type="button"
          class="send-message-mic"
          :aria-label="rotulosDeVoz.ditar"
          :title="rotulosDeVoz.ditar"
          @click="iniciarDitar"
        >
          <!-- [feedback do usuário, 04/09 — 2ª rodada] 13px é o canônico dos
               ícones "só-ícone" do composer (agent-select/escopo-select —
               `composer-inline-select.js`'s `tamanhoDoIcone`, default 13);
               16 destoava da régua dos vizinhos. -->
          <icon-svg name="microphone" :size="13" color="var(--neutral-700)" />
        </button>

        <!-- [feedback do usuário, 04/09] "eu nunca consigo... sair da
             conversa contínua" — X neutro (mesma linguagem de "cancelar" do
             Ditar, abaixo), visível sempre que a sessão de Modo de Voz está
             ativa mas NÃO gravando (a IA falando, ou o respiro antes do
             re-arme automático do mic — os dois momentos em que `gravando`
             já é `false` mas ainda se está "dentro" da conversa contínua).
             Sai de vez, sem transcrever nem enviar nada — diferente do X
             PRETO que aparece GRAVANDO logo abaixo (`send-message-voz-
             parar`), que PARA E ENVIA. -->
        <button
          v-if="sessaoDeVozAtiva && !gravando"
          type="button"
          class="send-message-ditar-acao send-message-ditar-acao--cancelar"
          :aria-label="rotulosDeVoz.sairDoModoDeVoz"
          :title="rotulosDeVoz.sairDoModoDeVoz"
          @click="sairDoModoDeVoz"
        >
          <icon-svg name="close" :size="13" color="var(--neutral-700)" />
        </button>

        <!-- [feedback do usuário, 04/09 — pivô ChatGPT] Modo de Voz: mudo (à
             esquerda, alterna o microfone SEM parar a gravação —
             `definirMudo` em `captura-de-voz.js`) + X preto (para E ENVIA —
             "tem q ser igual ao chat gpt": reusa `pararGravacao`, que já
             transcreve e emite `enviar-voz`; Esc continua sendo o
             cancelamento de verdade). O ícone do mudo troca de glifo E de
             cor — vermelho quando mutado é o mesmo vocabulário de "ação
             destrutiva/atenção" do resto do design-system. -->
        <template v-else-if="gravando && modoDeVoz">
          <button
            type="button"
            class="send-message-mudo"
            :class="{ 'send-message-mudo--ativo': microfoneMutado }"
            :aria-label="rotuloMutar"
            :title="rotuloMutar"
            :aria-pressed="mudoAriaPressed"
            @click="alternarMudo"
          >
            <icon-svg
              :name="microfoneMutado ? 'microphone-off' : 'microphone'"
              :size="13"
              :color="
                microfoneMutado ? 'var(--danger-text)' : 'var(--neutral-700)'
              "
            />
          </button>
          <!-- ★ [T049] O X PRETO só existe onde existe turno a PARAR E ENVIAR
               — o caminho por turnos. Em tempo real quem julga o fim do turno
               é o provedor, e este botão chamava `parar()`, que é no-op lá:
               era o único X visível na sessão e não fechava nada, numa conversa
               paga por minuto. -->
          <button
            v-if="podeParaEEnviar"
            type="button"
            class="send-message-voz-parar"
            data-teste="voz-parar-e-enviar"
            :aria-label="rotulosDeVoz.pararEEnviar"
            :title="rotulosDeVoz.pararEEnviarDica"
            @click="pararGravacao"
          >
            <icon-svg name="close" :size="14" color="var(--white)" />
          </button>
          <!-- ★ [T049] Sem turno a parar, o X é o de SAIR — mesmo verbo, mesma
               linguagem visual e mesmo rótulo do X neutro lá de cima. Encerra a
               sessão de verdade (fecha o canal, solta o microfone, registra o
               consumo); o mudo ao lado continua valendo nos dois caminhos. -->
          <button
            v-else
            type="button"
            class="send-message-ditar-acao send-message-ditar-acao--cancelar"
            data-teste="voz-sair"
            :aria-label="rotulosDeVoz.sairDoModoDeVoz"
            :title="rotulosDeVoz.sairDoModoDeVoz"
            @click="sairDoModoDeVoz"
          >
            <icon-svg name="close" :size="13" color="var(--neutral-700)" />
          </button>
        </template>

        <!-- [feedback do usuário, 04/09 — pivô ChatGPT] Ditar: X (cancela) e
             ✓ (confirma — transcreve e preenche o campo, com loading
             enquanto `transcrevendo`). Reusa `cancelarGravacaoPorEsc`/
             `pararGravacao` que já existiam pro Esc/clique único. -->
        <template v-else-if="gravando">
          <button
            type="button"
            class="send-message-ditar-acao send-message-ditar-acao--cancelar"
            :aria-label="rotulosDeVoz.cancelarDitado"
            :title="rotulosDeVoz.cancelarDitadoDica"
            :disabled="transcrevendo"
            @click="cancelarGravacaoPorEsc"
          >
            <icon-svg name="close" :size="13" color="var(--neutral-700)" />
          </button>
          <button
            type="button"
            class="send-message-ditar-acao send-message-ditar-acao--confirmar"
            :aria-label="rotulosDeVoz.concluirDitado"
            :title="rotulosDeVoz.concluirDitado"
            :disabled="transcrevendo"
            @click="pararGravacao"
          >
            <v-progress-circular
              v-if="transcrevendo"
              indeterminate
              size="14"
              width="2"
              color="white"
            />
            <!-- [feedback do usuário, 04/09 — 5ª rodada] "aumente o icone do
                 botao Concluir ditado" — 13 ficava perdido no círculo de
                 34px; 17 é o mesmo peso visual do ícone do enviar (15) mais
                 um passo, já que este É a ação que conclui o gesto. -->
            <icon-svg
              v-else
              name="check-circle"
              :size="17"
              color="var(--white)"
            />
          </button>
        </template>

        <!-- Slot único: troca enviar <-> iniciar-voz <-> parar no MESMO botão
             (não empilha três), senão o layout "pula". Botão circular
             PREENCHIDO, como no protótipo — no mesmo molde de 30px do
             `.send-message-anexo` do outro lado da barra. -->
        <button
          v-if="!gravando"
          type="button"
          class="send-message-enviar"
          :class="classesDoBotaoEnviar"
          :style="estiloDoPulsoDeEnvio"
          :disabled="!loading && !canSend && !mostraIniciarVoz"
          :aria-label="rotuloBotaoAcao"
          :title="rotuloBotaoAcao"
          @click="aoClicarEnviar"
        >
          <icon-svg
            :name="iconeDoBotaoEnviar"
            :size="loading ? 13 : 15"
            :color="corDoBotaoEnviar"
          />
        </button>
      </div>
    </div>
    <!-- A linha do hint: o texto de sempre (teclado ou disclaimer). O aviso de
         saldo baixo morou aqui entre 14 e 15/09/2026 e subiu para a aba
         (`cabecalho`) — o usuário achou a linha poluída com dois textos. -->
    <!-- O link "Suporte no WhatsApp" morou aqui até 17/09/2026 e SAIU: o
         suporte virou um cartão próprio (`suporte-whatsapp-card.vue`), abaixo
         do composer no estado vazio e no pé do painel da conversa. Manter os
         dois deixaria o MESMO destino duas vezes na tela. Sem ele a linha
         guarda só o texto do rodapé, encostado à direita. -->
    <!-- ⚠️ `v-if` no CONTÊINER, e não só no texto: a linha tem `margin-top: 8px`
         e `margin-bottom: 4px` próprios, então um `<span>` vazio dentro dela
         ainda cobraria 12px abaixo do composer — justamente o que esta mudança
         foi buscar. -->
    <div
      v-if="textoRodape"
      class="send-message-hint ia-texto-auxiliar d-flex align-center az-gap justify-end"
    >
      <span
        class="send-message-hint__texto az-text-secondary az-muted ia-texto-auxiliar text-right"
        >{{ textoRodape }}</span
      >
    </div>
  </div>
</template>

<style lang="sass" scoped>
// [spec-008 T030c] O `<audio>` da voz em tempo real não ocupa espaço: sem
// `controls` ele já não desenha nada em navegador nenhum, mas `display: none`
// é o que garante que ele não entre no fluxo do flex da caixa — um irmão de
// altura zero ainda participa de `gap`, e a caixa ganharia um respiro
// fantasma em TODAS as superfícies que montam este composer.
//
// ⚠️ `display: none` NÃO impede a reprodução: quem toca é o elemento de
// mídia, não o layout (`HTMLMediaElement.play()` independe de estar pintado).
.send-message-audio-da-voz
  display: none

.send-message-aviso-anexo
  display: flex
  align-items: center
  gap: 4px
  // Alinha com o respiro da fila logo acima (`__lista`, 8px), e fecha a faixa
  // antes da linha de controles.
  padding: 0 8px 6px
  // O passo de 11px vem de `design/_ia-texto.sass` (classe no template).
  color: var(--neutral-700)

.send-message-wrapper
  // Sem borda no topo: a caixa flutuante já se separa do conteúdo pela sombra,
  // e o filete duplicava a divisão. Acompanha o fundo do conteúdo para o rodapé
  // não desenhar uma faixa branca sob a conversa.
  background: var(--ia-content-bg)
  // ★ [T061] A orb NÃO depende mais deste `position: relative` — ela entrou
  // no fluxo (`composer-voz-orb.vue`) justamente para deixar de pousar sobre
  // a conversa. A declaração fica porque o wrapper segue sendo a referência
  // de posicionamento do que ainda é absoluto aqui dentro, e porque tirá-la
  // mudaria o containing block de tudo que um dia venha a ser — mas nenhuma
  // regra desta folha estiliza o filho, e isso continua sendo de propósito
  // (ver o comentário em `composer-voz-orb.vue` sobre o bug real que a
  // classe do pai colidindo com a raiz do filho já causou).
  position: relative

.send-message-inner
  // Referência de posicionamento do menu de ferramentas, que abre na largura
  // desta caixa (ver `larguraTotal` no `composer-inline-select`). Sem isto o
  // `left: 0; right: 0` dele resolveria contra um ancestral qualquer.
  //
  // ⚠️ Nada de `overflow: hidden` aqui: o menu é filho e seria recortado.
  position: relative
  // Transparente em repouso, não ausente: no protótipo a entrada na caixa é um
  // degradê (sombra), sem linha nítida. Manter 1px reservado evita salto de
  // layout quando o `:focus-within` acende a cor — que é a única pista visual
  // de foco por teclado deste campo.
  border: 1px solid transparent
  border-radius: 24px
  background: var(--white)
  box-shadow: var(--shadow-composer)
  transition: box-shadow 0.15s, border-color 0.15s

  &:focus-within
    border-color: var(--neutral-200)
    box-shadow: var(--shadow-composer-focus)

.send-message-inner--large
  // Estado vazio: a caixa é o centro da tela e ganha o raio maior do protótipo.
  border-radius: 28px

// ── Composer do modo limpo: uma linha fina ──────────────────────────────────
//
// O cabeçalho da caixa (slot `cabecalho`) — a ABA atrás do composer, no
// desenho de referência do usuário (14/09/2026): irmã ANTES da caixa, um pouco
// mais estreita que ela (recuo lateral), raio só nos cantos de cima, a MESMA
// borda da caixa do modo limpo (`--neutral-200`) nas laterais e em cima, e SEM
// borda embaixo — a base entra atrás da caixa branca pela margem negativa, e a
// caixa (irmã seguinte, `position: relative`) pinta por cima com a própria
// sombra. A aba é dona do fundo, da borda, do raio e do recuo; quem mora nela
// (`composer-aviso`, `composer-atencao`) desenha só o conteúdo: ícone, texto,
// link.
$send-message-aba-sobreposicao: 10px

.send-message-cabecalho
  &:empty
    display: none
  margin: 0 12px (-$send-message-aba-sobreposicao)
  padding-bottom: $send-message-aba-sobreposicao
  border: 1px solid var(--neutral-200)
  border-bottom: 0
  border-radius: var(--radius-lg) var(--radius-lg) 0 0
  background: var(--sidebar-warm-bg)

// A aba abrindo/fechando: fade + a altura recolhendo (por `max-height`, teto
// folgado para uma linha de faixa) + 6px descendo atrás da caixa. `overflow:
// hidden` só durante a animação, para o conteúdo não vazar enquanto encolhe.
// Sem `mode`: a aba não troca de lugar com nada, só entra e sai.
$send-message-aba-altura-maxima: 96px
$send-message-aba-duracao: 220ms

.send-message-aba-enter-active,
.send-message-aba-leave-active
  overflow: hidden
  transition: opacity $send-message-aba-duracao var(--motion-easing-standard, ease-out), max-height $send-message-aba-duracao var(--motion-easing-standard, ease-out), transform $send-message-aba-duracao var(--motion-easing-standard, ease-out)

.send-message-aba-enter-to,
.send-message-aba-leave
  max-height: $send-message-aba-altura-maxima

.send-message-aba-enter,
.send-message-aba-leave-to
  opacity: 0
  max-height: 0
  transform: translateY(6px)

@media (prefers-reduced-motion: reduce)
  .send-message-aba-enter-active,
  .send-message-aba-leave-active
    transition: none

// Só aqui, e nunca na `.send-message-inner`: a mesma caixa serve outras quatro
// superfícies, que mantêm as duas fileiras.
.send-message-inner--limpo
  display: flex
  // ⚠️ `center`, e nada de `flex-end` — nem aqui nem por `align-self` nos
  // botões. Com `min-height: 52px` a linha de flex tem 52px, e `flex-end`
  // encosta os botões de 34px na base dela, deixando 18px de vazio em cima.
  // Compensar com padding também não serve: `box-sizing: border-box` o tira de
  // dentro do `min-height` e a caixa cresce parada. Quem leva os controles para
  // o rodapé é o layout de DUAS FILEIRAS (`--multilinha`), e só quando cresce.
  align-items: center
  // ⚠️ `nowrap` explícito. O `.send-message-textarea` tem `width: 100%` numa
  // regra global, e num flex que quebra linha isso o manda sozinho para a
  // fileira de baixo — controles em cima, campo embaixo. Foi o defeito da
  // primeira tentativa, e o que fazia a caixa PARECER alta.
  flex-wrap: nowrap
  gap: 6px
  // Borda SEMPRE visível nesta caixa, não só no foco. Sobre o fundo quase
  // branco (`#FCFCFC`) o branco do composer quase não se separa sozinho — o
  // contorno passou a ser o que desenha a caixa. O foco continua distinguível
  // porque escurece um passo (regra abaixo) e acende a sombra.
  border-color: var(--neutral-200)

  &:focus-within
    border-color: var(--neutral-300)
  // A altura do composer da referência.
  min-height: 52px
  // Simétrico: o "+" e o enviar ficam à MESMA distância das bordas.
  // ⚠️ Vertical ZERO de propósito: `box-sizing: border-box` faz o padding sair
  // de dentro do `min-height`, e qualquer valor aqui empurra a caixa para além
  // dos 52px em repouso.
  padding: 0 8px

  // `contents` dissolve a barra: o "+" mora DENTRO dela, depois do campo no
  // DOM, e nenhum `order` tira um filho de dentro do pai. Com a barra
  // dissolvida os filhos viram irmãos diretos do campo e passam a poder ser
  // ordenados — o DOM continua como está, que é o que serve as outras
  // superfícies. Funciona porque a `d-flex` não é aplicada neste modo.
  .send-message-toolbar
    display: contents

  // A ordem da referência: "+" na esquerda, campo no meio, ícones e enviar
  // encostados na direita.
  //
  // O ativador do tooltip se dissolve junto com a barra, senão o item de flex
  // seria ele (um span sem tamanho) e o botão dentro ficaria fora da ordem.
  // ★ DÍVIDA PAGA (a prévia dos anexos voltou ao fluxo).
  //
  // Aqui havia um `display: none` com a nota "no dia em que o anexo for
  // liberado, isto precisa voltar". O dia chegou. A causa dos ~16px que a fila
  // VAZIA ocupava não era o componente: era o `px-2 pt-1` no ponto de montagem,
  // que existia com ou sem item. O padding foi para
  // `.composer-attachments__lista`, que só renderiza com item — vazia, a fila
  // ocupa zero e o "+" volta a alinhar com o enviar sem precisar sumir com ela.
  //
  // ⚠️ E a faixa fica ACIMA da linha de controles, como a nota previa: numa
  // fileira de 52px uma miniatura de 72px não cabe. Quem empilha é o
  // `.send-message-inner`, que é coluna — a linha de 52px é a barra de dentro.

  .send-message-ferramentas,
  .send-message-anexo
    order: 1

  .send-message-ferramenta-chip
    order: 2

  .send-message-anexo
    order: 1
    // ★ 34px e não os 30 do composer padrão: nesta caixa de 52px os botões
    // ficavam pequenos demais para a altura da linha. Vale para os QUATRO —
    // "+", agente, escopo e enviar — senão a fileira fica desalinhada.
    // Mudou aqui, mude nos outros quatro (`grep -rn "34px e não os 30"`).
    width: 34px
    height: 34px

  .send-message-textarea
    order: 3
    // `width: auto` vence o `width: 100%` global; sem isso o `flex-basis` não
    // manda e o campo reserva a linha inteira para si.
    width: auto
    flex: 1 1 0
    min-width: 0

  .send-message-chips
    order: 4

  .send-message-mic,
  .send-message-enviar,
  .send-message-mudo,
  .send-message-voz-parar,
  .send-message-ditar-acao
    order: 5
    // [bug corrigido, 04/09] Faltava `order` aqui — as classes de estado da
    // gravação nascem sem ele, herdam `order: 0` (o padrão do flex) e pulam
    // pra FRENTE do "+" no modo `--limpo`, que dá `display: contents` no
    // toolbar (os filhos participam do flex do PAI, e no flex quem não
    // declara `order` vai pro início). Era exatamente o defeito que o
    // comentário do `.send-message-ferramenta-chip` (linha ~1593) já
    // registrava — e caiu de novo aqui por serem classes novas.
    //
    // [feedback do usuário, 04/09 — 3ª rodada] "a distancia do microfone ta
    // maior... para os botoes da esquerda e tambem da direita" — havia um
    // `margin-left: 8px` aqui, SOMADO ao `gap: 6px` que
    // `.send-message-inner--limpo` já aplica entre TODOS os irmãos da
    // fileira (14px no total, contra os 4px do gap interno dos chips ao
    // lado). Removido: o `gap` do container já basta, e agora o espaço
    // antes/depois do mic é o MESMO que entre os outros itens da fileira.

  .send-message-mic,
  .send-message-enviar
    width: 34px
    height: 34px

  // O espaçador não tem mais o que empurrar: quem ocupa a sobra é o campo, e é
  // ele que joga para a direita tudo o que vem depois.
  .flex-grow-1
    display: none

  // Campo de UMA linha em repouso. O `auto-grow` do Vuetify segue valendo
  // quando o texto passa da largura.
  .send-message-textarea ::v-deep .v-input__slot,
  .send-message-textarea ::v-deep .v-text-field__slot
    margin-bottom: 0
    padding: 0

// ---------------------------------------------------------------------------
// Modo limpo, campo com MAIS DE UMA LINHA — duas fileiras.
//
// ★ Só assim a barra de rolagem alcança a borda direita da caixa, que é o
// desenho da referência: com os botões ladeando o campo, ela fica presa no meio
// e lê como divisória. Campo em cima ocupando a largura toda, controles numa
// fileira embaixo.
//
// ⚠️ Aqui o `wrap` é INTENCIONAL. O comentário do bloco acima registra que ele
// já causou defeito — o campo indo sozinho para a fileira de baixo. É
// exatamente o que se quer agora, só que na ordem inversa: campo em CIMA. Por
// isso os `order` são reescritos, e não herdados.
// ---------------------------------------------------------------------------
.send-message-inner--multilinha
  flex-wrap: wrap
  align-items: center
  // Aqui o padding vertical PODE existir: a caixa já passou dos 52px, então não
  // há `min-height` para estourar (ver o aviso no bloco de uma linha).
  padding: 8px

  // ★ O chip FLUTUA sobre a primeira linha do texto, como no ChatGPT.
  //
  // Lá o campo é um `contenteditable` e o chip é um nó no meio do conteúdo.
  // Aqui é um `<textarea>`, que só aceita texto — então ele sai do fluxo e o
  // `text-indent` (regra abaixo) abre o buraco exato para ele na primeira
  // linha. As seguintes voltam à margem, igual à referência.
  //
  // ⚠️ Antes ele era item de flex sem `order` reatribuído neste bloco, herdava
  // o `order: 2` do `--limpo` — o mesmo do "+" — e, empatado, o DOM desempatava:
  // o chip descia para a fileira de controles, colado no "+".
  //
  // `top`/`left` batem com onde o texto começa: 8px do padding da caixa + 1 do
  // campo, e 16px na horizontal (9 do campo + 7 do padding do textarea).
  .send-message-ferramenta-chip
    position: absolute
    // ⚠️ Alinhado com a PRIMEIRA LINHA do texto, não com o topo da caixa.
    // Medido: com `top: 9px` o centro do chip ficava 11px acima do centro da
    // linha, e ele lia como um bloco pairando em vez de uma palavra na frase.
    //
    // 22px = 8 (padding da caixa) + 7 (offset do campo) + 7 (padding-top do
    // textarea) — é onde a caixa de linha do texto começa. O `height` de 18px
    // é o `line-height` do campo: mesma altura de linha, mesmo eixo.
    // ⚠️ Medido em runtime (`medirTopoDaLinha`), não somado à mão: escrito como
    // `8 + 7 + 7 = 22px` este número já desalinhou o chip duas vezes, porque
    // quem o compõe são quatro paddings de camadas diferentes. O fallback só
    // vale até a primeira medição.
    top: var(--topo-da-linha, 22px)
    left: 16px
    // Acompanha a rolagem do texto — `--rolagem` vem do `estiloDoChip`.
    transform: translateY(calc(-1 * var(--rolagem, 0px)))
    // ⚠️ O corte é na borda do CAMPO, não na da caixa. O texto que rolou some
    // no topo do textarea (15px = 8 do padding da caixa + 7 do offset do
    // campo); o `overflow` da caixa corta só em 0, então sobravam 7px de
    // padding em que o chip continuava aparecendo sobre um texto já cortado.
    // 7px = os 22 do chip menos os 15 da borda do campo.
    clip-path: inset(max(0px, var(--rolagem, 0px) - 7px) 0 0 0)
    height: 18px
    line-height: 18px
    align-items: center
    // Acima do campo, senão o clique no chip cai no textarea.
    z-index: 1

  .send-message-textarea
    order: 1
    // A fileira inteira para o campo — é o que leva a barra até a borda.
    flex: 1 1 100%
    width: 100%
    margin-bottom: 4px

  // O texto alinha com o ÍCONE do "+", não com a borda da caixa.
  //
  // Ocupando a fileira inteira, o campo não tem recuo próprio e o texto
  // começava nos 8px do padding da caixa — enquanto o ícone do "+" logo abaixo
  // começa nos 15px (8 do padding + 7 de centragem dentro dos 34px do botão).
  // Sete pixels de diferença bastam para o texto parecer colado na parede.
  //
  // ⚠️ O padding vai no `<textarea>`, e NÃO no wrapper: a barra de rolagem é
  // desenhada na borda do elemento que rola, fora da caixa de padding. No
  // wrapper, ela entraria junto e sairia da borda da caixa — que é justamente o
  // desenho que o modo de duas fileiras existe para conseguir (ver o ★ acima).
  // ⚠️ O Vuetify põe `margin-right: -12px` no `.v-text-field__slot` (folga do
  // ícone de append, que aqui não existe). Ocupando a fileira inteira, esse
  // valor negativo jogava o campo 3px para FORA da caixa: texto colado na
  // parede esquerda e passando da borda direita ao mesmo tempo. Medido no
  // navegador — esquerda 9px, direita −3px.
  .send-message-textarea ::v-deep .v-text-field__slot
    margin-right: 0

  // Com a caixa simétrica, o texto alinha com o ÍCONE do "+" nos dois lados:
  // 9px do campo + 7 daqui = 16px, que é onde o ícone começa (8 do padding da
  // caixa + 7 de centragem nos 34px do botão).
  //
  // ⚠️ No `<textarea>`, e NÃO no wrapper: a barra de rolagem é desenhada na
  // borda do elemento que rola, fora da caixa de padding. No wrapper ela entraria
  // junto e sairia da borda — o desenho que o modo de duas fileiras existe para
  // conseguir (ver o ★ acima).
  .send-message-textarea ::v-deep textarea
    padding-left: 7px
    padding-right: 7px
    // O buraco da primeira linha para o chip flutuante. `0px` quando não há
    // ferramenta escolhida — a variável vem da caixa (`estiloDaCaixa`), medida
    // no DOM porque a largura depende do rótulo.
    text-indent: var(--recuo-do-chip, 0px)

  .send-message-ferramentas,
  .send-message-anexo
    order: 2

  // `auto` empurra os chips e o enviar para a direita, deixando o "+" sozinho
  // à esquerda. Sem isto os três ficariam colados no "+", que é o oposto.
  .send-message-chips
    order: 3
    margin-left: auto

  .send-message-mic,
  .send-message-enviar,
  .send-message-mudo,
  .send-message-voz-parar,
  .send-message-ditar-acao
    order: 4


// A faixa de anexos ocupa a PRÓPRIA fileira, acima dos controles.
//
// ★ Mesmo mecanismo do `--multilinha` acima, e pelo mesmo motivo: a caixa do
// modo limpo é `flex-wrap: nowrap`, então tudo que entra nela vira item da
// fileira de 52px — foi assim que miniatura, chip e aviso apareceram ao lado do
// "+" e do campo. Com `wrap` ligado, quem tem base de 100% forma linha própria,
// e a faixa vem primeiro por não ter `order` (os controles têm 1 a 5).
//
// ⚠️ Bloco DEPOIS do `--multilinha` inteiro, e não no meio dele. Em Sass
// INDENTADO uma regra de nível zero adota tudo o que vem abaixo: posto entre o
// `padding` do `--multilinha` e as regras aninhadas dele, roubou o `order` do
// campo e dos botões — o campo foi para uma fileira e o "+" para outra.
//
// ⚠️ E foi o que a nota de dívida previa em 26/08: "provavelmente como uma
// faixa ACIMA da linha, já que numa fileira de 52px não cabe". A miniatura tem
// 72px.
.send-message-inner--com-anexos
  flex-wrap: wrap
  // Vertical só embaixo: em cima quem dá o respiro é o padding da própria fila
  // (`__lista`), e somar os dois afastaria a miniatura da borda.
  padding: 0 8px 8px

  .composer-attachments,
  .send-message-aviso-anexo
    flex: 0 0 100%

// Arrastando por cima: a caixa INTEIRA é o alvo, e ela diz isso pela borda.
//
// ★ Sem dropzone tracejada própria. O composer já é uma caixa delimitada — uma
// segunda moldura dentro dela seria um alvo dentro do alvo, quando na verdade o
// arquivo pode cair em qualquer ponto. Só borda e fundo mudam de tom.
// ⚠️ Classe DOBRADA (0,2,0). `--limpo` fixa `border-color: var(--neutral-200)`
// com a mesma especificidade (0,1,0), e empatado o desempate é a ordem — que
// muda com a ordem de injeção do vue-style-loader, não com a do arquivo. Medido:
// o fundo desta regra aplicava e a BORDA não. Mesmo remédio da
// `.chat-sidebar.chat-sidebar--recolhida`.
.send-message-inner.send-message-inner--arrastando
  border-color: var(--primary)
  background: var(--neutral-50)

.send-message-textarea
  background: transparent !important
  width: 100%

.send-message-textarea ::v-deep .v-input__slot
  // Variant `solo` do Vuetify pinta um fundo branco proprio no slot interno,
  // que cobre o cinza de .send-message-inner por cima — sem isso o campo
  // continua parecendo branco mesmo com o pai correto.
  background: transparent !important
  box-shadow: none !important

.send-message-toolbar
  // Toolbar do rodape do composer (modelo/persona/thinking/enviar) — mesma
  // caixa do textarea, nao mais uma linha separada fora dela.
  width: 100%

  // Mesma armadilha do `.send-message-chips` abaixo, um nível acima: o
  // `v-tooltip` do "+" embrulha o botão num span 0×0 que também soma o `gap`
  // dos dois lados — aqui de 8px, ou seja, 16px em volta de um botão só.
  ::v-deep .v-tooltip
    display: contents

.send-message-chips
  // Menor que o `az-gap-small` da toolbar de proposito: a toolbar separa GRUPOS
  // (anexos, chips, thinking, enviar) e os chips sao um grupo so.
  gap: 4px
  min-width: 0

  // ★ O `EscopoSelect` tem `<v-menu>` como RAIZ, e o Vuetify 2 embrulha o
  // ativador num `div.v-menu.v-menu--inline` que mede 0×0 — mas continua sendo
  // um item de flex real. O `gap` conta antes E depois dele, então o espaço
  // até o Escopo era o DOBRO do que há entre Agente e Modelo, sem nenhuma
  // margem escrita em lugar nenhum. `display: contents` tira o wrapper da
  // árvore de layout sem afetar o ativador nem o menu teletransportado.
  // Armadilha registrada no CLAUDE.md da raiz; mesmos precedentes de
  // `suggestion-card.vue` e `chat-message-actions.vue`.
  ::v-deep .v-menu
    display: contents

.send-message-model-select
  flex-shrink: 0

// O trigger neutro do ComposerInlineSelect fazia o chip de modelo destoar dos
// vizinhos na mesma fileira.
.send-message-model-select ::v-deep .composer-inline-select__trigger
  // Mesma receita nos três chips do composer — agente, modelo e escopo.
  // Mudou aqui, mude nos outros dois (`grep -rn "chip do composer"`).
  border-radius: 999px
  padding: 4px 10px
  background: var(--neutral-100)
  color: var(--neutral-900)

  &:hover,
  &.composer-inline-select__trigger--open
    background: var(--neutral-200)

.send-message-textarea ::v-deep textarea
  // Vuetify reserva 12px de margin-top no textarea pro label flutuante
  // mesmo sem label/single-line. !important necessario pra vencer a
  // especificidade maior do seletor Vuetify
  // (.v-textarea.v-text-field--enclosed.v-text-field--single-line).
  margin-top: 0 !important
  font-size: var(--ia-font-corpo)
  // Teto do auto-grow (S2/AC-3.5): o `auto-grow` do Vuetify escreve a altura
  // inline conforme o conteúdo; sem teto, um texto longo empurra as mensagens
  // pra fora da tela. Passando daqui, rola dentro do próprio campo.
  max-height: 200px
  overflow-y: auto

  // ⚠️ A barra é do PRÓPRIO textarea (é o `overflow-y` daqui que a liga), e sem
  // esta receita ela usava o trilho global (`design/index.sass`), pintado de
  // `--neutral-50`. Sobre o branco do composer aquilo virava um filete vertical
  // de altura cheia separando o texto dos ícones — parecia divisória, não barra.
  //
  // Trilho TRANSPARENTE em vez de branco fixo: acompanha a superfície sozinho,
  // inclusive se ela mudar de tom. Mesma receita da lateral (`chat-sidebar.vue`)
  // e da lista de ações (`acoes-por-modulo.vue`), registrada no CLAUDE.md do
  // módulo como o padrão daqui.
  &::-webkit-scrollbar-track
    background: transparent

  &::-webkit-scrollbar-thumb
    background: var(--sidebar-warm-border)
    box-shadow: none

    &:hover
      background: var(--neutral-300)

  // Firefox não tem os pseudo-elementos acima; `scrollbar-color` é o
  // equivalente (polegar, trilho).
  scrollbar-width: thin
  scrollbar-color: var(--sidebar-warm-border) transparent

.send-message-anexo
  display: inline-flex
  align-items: center
  justify-content: center
  // 30px casa com a altura do chip de agente ao lado; 26px deixava o botão
  // visivelmente menor e criava um buraco entre os dois.
  width: 30px
  height: 30px
  border: 0
  border-radius: 50%
  background: none
  cursor: pointer
  flex-shrink: 0
  // Mesmo hover de `agent-select.vue`/`escopo-select.vue`/`.send-message-mic`
  // (--neutral-200) — os "só-ícone" do composer leem como a mesma família.
  &:hover
    background: var(--neutral-200)
  &:disabled
    cursor: not-allowed
    opacity: 0.45

// Mesmo alvo de 30px do `.send-message-anexo`, do outro lado da barra.
.send-message-enviar
  display: inline-flex
  align-items: center
  justify-content: center
  width: 30px
  height: 30px
  border: 0
  border-radius: 50%
  background: var(--neutral-100)
  cursor: pointer
  flex-shrink: 0
  transition: background-color 0.15s, filter 0.15s

  &:hover:not(:disabled)
    background: var(--sidebar-warm-hover)

  &:disabled
    cursor: not-allowed

.send-message-enviar--pronto
  background: var(--primary)

  &:hover:not(:disabled)
    background: var(--primary)
    filter: brightness(0.94)

.send-message-enviar--parar
  background: var(--danger-bg-soft)

// [feedback do usuário, 04/09 — pivô ChatGPT] Bolha de "iniciar modo de voz"
// — campo vazio e parado. Preenchida em `--primary` como o enviar "pronto"
// (é a ação primária disponível nesse estado); ganha uma leve animação no
// hover, como a referência ("no hover tem animacao").
.send-message-enviar--iniciar-voz
  background: var(--primary)

  &:hover:not(:disabled)
    background: var(--primary)
    filter: brightness(0.94)
    transform: scale(1.06)

  // ⚠️ `@keyframes` não é escopado pelo `<style scoped>` do Vue — só
  // seletores recebem o atributo `data-v-xxx`. `audioLinesPulse` é declarado
  // em `audio-lines.vue` e pode ser referenciado por nome daqui: no hover da
  // bolha, as barras do ícone pulsam, em vez de ficarem estáticas
  // ("no hover tem animacao ok?").
  &:hover:not(:disabled) ::v-deep .audio-lines-icon__bar
    animation: audioLinesPulse 0.9s ease-in-out infinite

    &--1
      animation-delay: 0s
    &--2
      animation-delay: 0.15s
    &--3
      animation-delay: 0.3s
    &--4
      animation-delay: 0.45s

  @media (prefers-reduced-motion: reduce)
    &:hover:not(:disabled) ::v-deep .audio-lines-icon__bar
      animation: none

// Mic PLANO — MESMA receita de `.send-message-anexo` logo acima (círculo
// transparente, hover neutral-100), pra não divergir dela com o tempo. Base
// 30px como o "+" no composer padrão; sobe a 34px dentro de `--limpo`
// (seletor mais abaixo), igual aos outros três da fileira.
//
// [feedback do usuário, 04/09 — 2ª rodada] "nao esta no mesmo padrao do
// escopo-select" — o círculo/hover já eram os mesmos; o que destoava era o
// TAMANHO do ícone (16 em vez do 13 canônico dos chips só-ícone, ver o
// template) e o tamanho BASE deste botão (34 fixo, contra os 30 do "+" fora
// do modo limpo). `grep -rn "34px e não os 30"` continua valendo.
.send-message-mic
  display: inline-flex
  align-items: center
  justify-content: center
  width: 30px
  height: 30px
  border: 0
  border-radius: 50%
  background: transparent
  cursor: pointer
  flex-shrink: 0
  transition: background-color 0.15s

  // [feedback do usuário, 04/09 — 3ª rodada] "botoes de agente e cliente e
  // microfone estao DIFERENTES... principalmente o hover" — `agent-select.vue`
  // e `escopo-select.vue` hover pra `--neutral-200` (regra incondicional dos
  // dois: `.agent-select ::v-deep .composer-inline-select__trigger:hover` /
  // `.escopo-select__caixa:hover`, que vale mesmo em `so-icone`). `--neutral-100`
  // era mais claro e ficava perceptivelmente diferente lado a lado.
  &:hover
    background: var(--neutral-200)

  &:focus-visible
    outline: 2px solid var(--primary)
    outline-offset: 2px

// [feedback do usuário, 04/09 — pivô ChatGPT] Modo de Voz tem DOIS botões
// (mudo + X preto), não um só. Mesma régua 34px dos vizinhos do composer.
//
// [bug corrigido, 04/09 — 5ª rodada] "os botoes estao mudando de lugar e
// deslocando" — MEDIDO no navegador (getBoundingClientRect, com o estado
// forçado via console): `margin-right: 6px` aqui (e no
// `.send-message-ditar-acao--cancelar`, abaixo) SOMAVA ao `gap: 6px` que o
// container já aplica entre TODOS os irmãos — 12px entre o par, contra 6px
// em qualquer outro lugar da fileira. Como o espectro/textarea é o ÚNICO
// item com `flex-grow`, ele "paga" essa diferença encolhendo 6px a mais —
// e é exatamente por isso que "+", chips e o resto inteiro pareciam ter
// deslocado ao entrar em Ditar/Modo de Voz: o TOTAL ocupado pela fileira
// não mudava, só a fronteira entre o espectro e os botões. Removido — o
// `gap` do container já basta, uniforme com o resto.
.send-message-mudo
  display: inline-flex
  align-items: center
  justify-content: center
  width: 34px
  height: 34px
  border: 0
  border-radius: 50%
  background: transparent
  cursor: pointer
  flex-shrink: 0
  transition: background-color 0.15s

  &:hover
    background: var(--neutral-200)

.send-message-mudo--ativo
  background: var(--danger-bg-soft)

  &:hover
    background: var(--danger-bg-soft)
    filter: brightness(0.96)

// [feedback do usuário, 04/09 — pivô ChatGPT] X preto simples — "tem q ser
// igual ao chat gpt". Substituiu a pílula "Parar" do desenho anterior
// (Claude): aqui o X PARA E ENVIA (`pararGravacao`), nunca cancela — Esc
// continua sendo o cancelamento de verdade.
.send-message-voz-parar
  display: inline-flex
  align-items: center
  justify-content: center
  width: 34px
  height: 34px
  border: 0
  border-radius: 50%
  background: var(--neutral-900)
  cursor: pointer
  flex-shrink: 0
  transition: filter 0.15s

  &:hover
    filter: brightness(1.15)

// [feedback do usuário, 04/09 — 4ª rodada] Voltou a 34px — 28px deixou o
// PAR (cancelar/confirmar) visivelmente MENOR que o `.send-message-mudo`/
// `.send-message-voz-parar` (Modo de Voz) e o `.send-message-enviar` de
// sempre, todos 34px na mesma fileira. É a mesma régua dos vizinhos; o
// "muito grande" da rodada anterior era o ÍCONE (15px, já reduzido a 13),
// não o botão.
.send-message-ditar-acao
  display: inline-flex
  align-items: center
  justify-content: center
  width: 34px
  height: 34px
  border: 0
  border-radius: 50%
  cursor: pointer
  flex-shrink: 0
  transition: background-color 0.15s, filter 0.15s

.send-message-ditar-acao--cancelar
  background: transparent

  &:hover
    background: var(--neutral-200)

.send-message-ditar-acao--confirmar
  background: var(--primary)

  &:hover
    background: var(--primary)
    filter: brightness(0.94)

.send-message-locked-hint
  color: var(--neutral-700)
  // ★ A quebra em duas linhas NÃO era o tamanho do texto: este era o único
  // item encolhível da toolbar (os três chips e o `.ia-thinking-chip` são
  // todos `flex-shrink: 0`), então toda a falta de espaço sobrava para ele,
  // que encolhia até min-content. Mesma receita do chip de raciocínio ao lado.
  white-space: nowrap
  flex-shrink: 0

.send-message-hint
  margin-top: 8px
  margin-bottom: 4px
  // Recua junto com a curva do composer: a caixa tem raio 24px, então o texto
  // encostado na borda ficava visualmente FORA dela. 16px alinha com onde a
  // linha reta do campo começa. Antes era o `pr-1` (4px) no template.
  padding-right: 16px
  padding-left: 16px

.send-message-hint__texto
  // ⚠️ O tamanho vem da classe `ia-texto-auxiliar` no template, NUNCA daqui nem por
  // herança do pai: o próprio elemento leva `az-text-secondary`, que declara
  // `font-size` com a mesma especificidade (0,1,0) e VENCE o que o pai herda.
  // Foi o que aconteceu ao remover a declaração local achando que era morta —
  // a linha voltou a 14px (17/09/2026). `_ia-texto.sass` entra depois de
  // `aawz/az-text` no `index.sass`, então a classe do módulo ganha.
  line-height: 16px

.ia-thinking-chip
  border-radius: 12px
  cursor: pointer
  border: 1px solid
  white-space: nowrap
  transition: background 0.15s, color 0.15s, border-color 0.15s
  background: none
  line-height: 18px

  &:disabled
    opacity: 0.5
    cursor: not-allowed

// Token, nunca hex: `--primary` é derivado por escritório (white-label), e o
// navy fixo que estava aqui apareceria em escritório de qualquer outra marca.
// `#EBF0F7` e `#C0C7D4` também não existiam na paleta.
.ia-thinking-chip--active
  color: var(--neutral-900)
  border-color: var(--neutral-700)
  background: var(--neutral-100)

.ia-thinking-chip--off
  // `--neutral-700` (6.74 sobre a superfície quente) e não `--neutral-600`,
  // que reprova AA ali — ver a tabela em `_controls.sass`.
  color: var(--neutral-700)
  border-color: var(--neutral-300)
  background: transparent

// Chip do comando (módulo ou atalho): o visual é do `comando-chip`; aqui só o
// teto de largura dentro da caixa.
.send-message-ferramenta-chip
  max-width: 40%

// Só enquanto a caixa abre ou fecha — ver `animarAlturaDaCaixa`. Permanente
// recortaria o menu de ferramentas, que é filho da caixa.
.send-message-inner--animando
  overflow: hidden
</style>
